import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getProjectID } from '../../../services/api.service';
import { bindActionCreators } from 'redux';
import { actionCreator } from '../../../store/index';
import CustomModal from '../../../services/CustomModal';
import Switch from '@mui/material/Switch';
import { Tooltip } from '@mui/material';
import {
  getEnableWelcomeMsg,
  getOrgUsersById,
  getUsersGlobalRole,
} from '../../../services/authService';
import { showToaster, ShowAlertBox, getUserItem } from '../../../services/helper';
import UserCreateModal from '../../container/role-table/createUser';
import UserRolepage from '../../container/role-table/roleAssign';

export default function Header(props) {
  const history = useHistory();
  const [newUser, setnewUser] = useState(undefined);
  const [ProjectName, setProjectName] = useState();
  const [isEditProjectName, setisEditProjectName] = useState(false);
  const [editProjectNameValue, seteditProjectNameValue] = useState(undefined);
  const params = useParams();
  let projectID = useSelector(state => state.project.ProjectId);
  const [OpenDashboard, setOpenDashboard] = useState(false);
  let state = useSelector(state => state);
  const [pageLoad, setPageLoad] = useState(false);
  let project = useSelector(state => state.project);
  let preview = useSelector(state => state.preview);
  let EditMode = useSelector(state => state.project.EditMode);
  let DisplayMode = useSelector(state => state.project.DisplayMode);
  let Toggleright = useSelector(state => state.project.togglerightscreen);
  let Toggleleft = useSelector(state => state.project.toggleleftscreen);
  const [createProjecteEnable, setCreateProjecteEnable] = useState(false);
  const [adduserEnable, setAdduserEnable] = useState(false);
  const [addUserPopup, setAddUserPopup] = useState(false);
  const [templateListEnable, setTemplateListEnable] = useState(false);
  const [templateUploadEnable, setTemplateUploadEnable] = useState(false);
  const [userDetails, setUserDetails] = useState(undefined);
  // let ProjectName = useSelector(state => {
  //   if(state.project.createdProject[projectID] != undefined){
  //     return state.project.createdProject[projectID].ProjectName
  //   }
  // })
  let userId = getUserItem('id');
  let Email = getUserItem('email');
  let userName = getUserItem('name');
  let AdminRole = getUserItem('role');
  let userParentId = getUserItem('orgId');
  const dispatch = useDispatch();
  const {
    ChangeProjectName,
    UpdateDisplayMode,
    Togglerightscreen,
    Toggleleftscreen,
    ChangeProjectNameInPreview,
  } = bindActionCreators(actionCreator, dispatch);

  // yuo can find all params from here

  const logout = () => {
    // localStorage.clear();
    localStorage.removeItem('_user');
    localStorage.removeItem('_olive_user');
    localStorage.removeItem('_s_admin_user');
    history.push('/');
  };
  const createProject = () => {
    // if (localStorage.getItem('_olive_user')) {

    history.push('/create-project');
    // }
  };
  const getuserGlobelRoles = () => {
    let RoleUserId = AdminRole == 0 ? userId : userParentId;
    getUsersGlobalRole(userId).then(response => {
      try {
        setPageLoad(true);
        if (
          response !== '' &&
          response !== undefined &&
          response !== null &&
          response.data !== '' &&
          response.data !== undefined &&
          response.data !== null &&
          response.data.result !== undefined &&
          response.data.result !== '' &&
          response.data.result !== null &&
          response.data.result[0] !== undefined &&
          response.data.result[0] !== '' &&
          response.data.result[0] !== null
        ) {
          // setCategoryList(ddd)
          setPageLoad(false);

          // setTimeout(() => {
          //     setprojectList(projectData2)
          // }, 1000);
          if (
            response.data.result[0].addProject !== undefined &&
            response.data.result[0].addUser !== undefined
          ) {
            setCreateProjecteEnable(response.data.result[0].addProject);
            setAdduserEnable(response.data.result[0].addUser);
          }

          // setTemplateListEnable(response.data.result[0].templateList)
          // setTemplateUploadEnable(response.data.result[0].templateUpload)
        } else {
          setPageLoad(false);
          // showToaster("Something went wrong. Please Try Again1", "warning");
        }
      } catch (error) {
        console.log(error);

        setPageLoad(false);
        showToaster('Something went wrong. Please Try Again', 'warning');
      }
    });
  };
  const getuserGlobelRolesAdmin = () => {
    let RoleUserId = AdminRole == 0 ? userId : userParentId;
    getUsersGlobalRole(RoleUserId).then(response => {
      try {
        setPageLoad(true);
        if (
          response !== '' &&
          response !== undefined &&
          response !== null &&
          response.data !== '' &&
          response.data !== undefined &&
          response.data !== null &&
          response.data.result !== undefined &&
          response.data.result !== '' &&
          response.data.result !== null &&
          response.data.result[0] !== undefined &&
          response.data.result[0] !== '' &&
          response.data.result[0] !== null
        ) {
          // setCategoryList(ddd)
          setPageLoad(false);
          getUserDetails();
          // setTimeout(() => {
          //     setprojectList(projectData2)
          // }, 1000);
          // setCreateProjecteEnable(response.data.result[0].addProject)
          // setAdduserEnable(response.data.result[0].addUser)
          if (response.data.result[0].templateList !== undefined) {
            setTemplateListEnable(response.data.result[0].templateList);
          }
          if (response.data.result[0].templateUpload !== undefined) {
            setTemplateUploadEnable(response.data.result[0].templateUpload);
          }
        } else {
          setPageLoad(false);
          // showToaster("Something went wrong. Please Try Again1", "warning");
        }
      } catch (error) {
        console.log(error);

        setPageLoad(false);
        showToaster('Something went wrong. Please Try Again', 'warning');
      }
    });
  };
  const getUserDetails = () => {
    let userid = AdminRole == 0 ? userId : userParentId;
    getOrgUsersById(userid).then(response => {
      try {
        setPageLoad(true);
        if (
          response !== '' &&
          response !== undefined &&
          response !== null &&
          response.data !== '' &&
          response.data !== undefined &&
          response.data !== null
        ) {
          setPageLoad(false);
          if (response.data.result != undefined) {
            let details = response.data.result.data;
            setUserDetails(details);
          }
        } else {
          setPageLoad(false);
          showToaster('Something went wrong. Please Try Again1', 'warning');
        }
      } catch (error) {
        console.log(error);
        setPageLoad(false);
        showToaster('Something went wrong. Please Try Again', 'warning');
      }
    });
  };
  useEffect(() => {
    let filter = {
      project_id: params.id,
    };
    getProjectID(filter).then(response => {
      try {
        if (
          response !== '' &&
          response !== undefined &&
          response !== null &&
          response.status !== '' &&
          response.status !== undefined &&
          response.status !== null &&
          response.status === 200 &&
          response.data !== '' &&
          response.data !== undefined &&
          response.data !== null
        ) {
          // let projectData = JSON.parse(response.data[0].ProjectData);
          setProjectName(response.data[0].ProjectName);
        }
      } catch (error) {}
    });
    getuserGlobelRoles();
    getuserGlobelRolesAdmin();
  }, []);

  useEffect(() => {
    if (
      history.location.pathname.includes('project-preview') ||
      history.location.pathname.includes('edit-project')
    ) {
      if (history.location.pathname.includes('project-preview')) {
        if (preview.previewProject[params.id] != null) {
          setProjectName(preview.previewProject[params.id].ProjectName);
        }
      } else {
        if (project.createdProject[projectID] != null) {
          setProjectName(project.createdProject[projectID].ProjectName);
        } else {
          //15 sec => redirect to project creation page
        }
      }
    } else {
      setProjectName('');
    }
  }, [project, preview]);

  const changeName = name => {
    if (history.location.pathname.includes('project-preview')) {
      ChangeProjectNameInPreview(name);
    } else {
      ChangeProjectName(name);
    }
  };

  const editProjectName = () => {
    if (
      editProjectNameValue == null ||
      editProjectNameValue == undefined ||
      editProjectNameValue == ''
    ) {
      if (history.location.pathname.includes('project-preview')) {
        ChangeProjectNameInPreview(ProjectName);
      } else {
        ChangeProjectName(ProjectName);
      }
    } else {
      // let filter = {
      //   project_id: params.id,
      //   projectName: editProjectNameValue,
      // };
      // updateProjects(filter)
      //   .then((res) => {
      //     if (history.location.pathname.includes("project-preview")) {
      //       ChangeProjectNameInPreview(editProjectNameValue);
      //     } else {
      //       ChangeProjectName(editProjectNameValue);
      //     }
      //   })
      //   .catch((error) => {
      //     if (history.location.pathname.includes("project-preview")) {
      //       ChangeProjectNameInPreview(ProjectName);
      //     } else {
      //       ChangeProjectName(ProjectName);
      //     }
      //   });

      if (history.location.pathname.includes('project-preview')) {
        ChangeProjectNameInPreview(editProjectNameValue);
      } else {
        ChangeProjectName(editProjectNameValue);
      }
    }
    seteditProjectNameValue(undefined);
    setisEditProjectName(false);
    if (props.setchanges !== undefined) {
      props.setchanges(true);
    }
  };

  //   const ChangeModuleNameBluroff = (name) => {
  //     if (name.length == 0) {
  //       ChangeProjectNameInPreview(name);
  //     }
  //     // setToggle(false)
  // }
  const onChange = e => {
    UpdateDisplayMode(e.target.checked);
  };

  const smallRightScreenToggle = () => {
    Togglerightscreen(!Toggleright);
  };
  const smallLeftScreenToggle = () => {
    Toggleleftscreen(!Toggleleft);
  };
  const backToDashboard = () => {
    history.push('/project-list');
  };
  const openTemplate = () => {
    history.push('/template-upload');
  };
  const openTemplatelist = () => {
    history.push('/templatelist');
  };
  const openRoleTable = () => {
    history.push('/user-roll');
  };
  const openOrgDashbaord = () => {
    history.push('/org/project-list');
  };
  const configSettings = () => {
    history.push('/admin/config-settings');
  };
  const createUser = () => {
    setAddUserPopup(true);
  };
  const orgSettings = () => {
    history.push('/admin/org-settings');
  };
  return (
    <>
      <div className="top-bar d-flex">
        <div
          className={!Toggleleft ? 'toggle-wrap aside-toggle' : 'toggle-wrap aside-toggle active'}
          onClick={smallLeftScreenToggle}
        >
          <span className="toggle-bar"></span>
        </div>
        {createProjecteEnable ? (
          <button
            type="button"
            className="btn create-btn"
            onClick={createProject}
            data-bs-toggle="modal"
            data-bs-target="#create-project"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.125 10H16.875"
                stroke=""
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 3.125V16.875"
                stroke=""
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            CREATE NEW PROJECT
          </button>
        ) : AdminRole == 0 ? (
          <button
            type="button"
            className="btn create-btn"
            onClick={createProject}
            data-bs-toggle="modal"
            data-bs-target="#create-project"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.125 10H16.875"
                stroke=""
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 3.125V16.875"
                stroke=""
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            CREATE NEW PROJECT
          </button>
        ) : (
          ''
        )}
        <div className="topbar-menu d-flex">
          {/* {
            params.id !== null &&
              params.id !== undefined &&
              params.id !== "" && (
                <input
                  type="text"
                  id="lname"
                  name="lname"
                  value={ProjectName}
                  onChange={(e) => changeName(e.target.value)}
                  // onBlur={() => ChangeModuleNameBluroff(ProjectName)}
                  autoFocus
                />
              )

            // <h3>{ProjectName}</h3>
          } */}

          <div className="d-flex topbar-wraper">
            <div className="d-flex label-edit align-items-center">
              <div className="edit-content">
                <input
                  className={isEditProjectName && 'input-border'}
                  autoFocus
                  disabled={!isEditProjectName}
                  type="text"
                  id="lname"
                  name="lname"
                  value={isEditProjectName ? editProjectNameValue : ProjectName}
                  onChange={e => seteditProjectNameValue(e.target.value)}
                />
              </div>
              {ProjectName != null && ProjectName != '' && ProjectName != undefined && (
                <div className="edit-icon d-flex">
                  {!isEditProjectName && (
                    <span
                      className="icon-wrap"
                      onClick={() => {
                        setisEditProjectName(true);
                        seteditProjectNameValue(ProjectName);
                      }}
                    >
                      <svg
                        width="16px"
                        height="16px"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        enable-background="new 0 0 512 512"
                      >
                        <g>
                          <g>
                            <path d="m455.1,137.9l-32.4,32.4-81-81.1 32.4-32.4c6.6-6.6 18.1-6.6 24.7,0l56.3,56.4c6.8,6.8 6.8,17.9 0,24.7zm-270.7,271l-81-81.1 209.4-209.7 81,81.1-209.4,209.7zm-99.7-42l60.6,60.7-84.4,23.8 23.8-84.5zm399.3-282.6l-56.3-56.4c-11-11-50.7-31.8-82.4,0l-285.3,285.5c-2.5,2.5-4.3,5.5-5.2,8.9l-43,153.1c-2,7.1 0.1,14.7 5.2,20 5.2,5.3 15.6,6.2 20,5.2l153-43.1c3.4-0.9 6.4-2.7 8.9-5.2l285.1-285.5c22.7-22.7 22.7-59.7 0-82.5z" />
                          </g>
                        </g>
                      </svg>
                    </span>
                  )}
                  {isEditProjectName && (
                    <>
                      <span
                        className="icon-wrap"
                        onClick={() => {
                          editProjectName();
                        }}
                      >
                        <svg
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          fill=""
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M19.8198 6.19526C20.0601 6.45561 20.0601 6.87772 19.8198 7.13807L9.9736 17.8047C9.73328 18.0651 9.34364 18.0651 9.10332 17.8047L4.18024 12.4714C3.93992 12.2111 3.93992 11.7889 4.18024 11.5286C4.42056 11.2682 4.8102 11.2682 5.05053 11.5286L9.53846 16.3905L18.9495 6.19526C19.1898 5.93491 19.5794 5.93491 19.8198 6.19526Z"
                            fill=""
                          />
                        </svg>
                      </span>
                      <span
                        className="icon-wrap"
                        onClick={() => {
                          setisEditProjectName(false);
                        }}
                      >
                        <svg
                          width="16px"
                          height="16px"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
                        </svg>
                      </span>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* <div className="d-flex label-select align-items-center">
                  <div className="edit-content">
                    <div className="d-flex">
                      <label className="pb-0">VR Education</label>
                      <span className="icon-wrap">
                        <svg width="16px" height="16px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
                          <g>
                            <g>
                              <path d="m455.1,137.9l-32.4,32.4-81-81.1 32.4-32.4c6.6-6.6 18.1-6.6 24.7,0l56.3,56.4c6.8,6.8 6.8,17.9 0,24.7zm-270.7,271l-81-81.1 209.4-209.7 81,81.1-209.4,209.7zm-99.7-42l60.6,60.7-84.4,23.8 23.8-84.5zm399.3-282.6l-56.3-56.4c-11-11-50.7-31.8-82.4,0l-285.3,285.5c-2.5,2.5-4.3,5.5-5.2,8.9l-43,153.1c-2,7.1 0.1,14.7 5.2,20 5.2,5.3 15.6,6.2 20,5.2l153-43.1c3.4-0.9 6.4-2.7 8.9-5.2l285.1-285.5c22.7-22.7 22.7-59.7 0-82.5z"/>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </div>
                    <div className="custom-select w-100">
                      <select className="form-select form-field">
                        <option> All Category</option>
                      </select>
                    </div>
                  </div>
                </div> */}
          </div>
          <ul className="d-flex ms-auto">
            <li className="me-3" style={{ cursor: 'pointer' }}>
              <a
                onClick={() => {
                  history.push('/');
                }}
              >
                <Tooltip title="Home" arrow>
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 26.39 26.39"
                    width="24"
                    height="24"
                  >
                    {' '}
                    <g>
                      {' '}
                      <g id="c14_house">
                        {' '}
                        <path d="M3.588,24.297c0,0-0.024,0.59,0.553,0.59c0.718,0,6.652-0.008,6.652-0.008l0.01-5.451c0,0-0.094-0.898,0.777-0.898h2.761 c1.031,0,0.968,0.898,0.968,0.898l-0.012,5.434c0,0,5.628,0,6.512,0c0.732,0,0.699-0.734,0.699-0.734V14.076L13.33,5.913 l-9.742,8.164C3.588,14.077,3.588,24.297,3.588,24.297z" />{' '}
                        <path d="M0,13.317c0,0,0.826,1.524,2.631,0l10.781-9.121l10.107,9.064c2.088,1.506,2.871,0,2.871,0L13.412,1.504L0,13.317z" />{' '}
                        <polygon points="23.273,4.175 20.674,4.175 20.685,7.328 23.273,9.525 		" />{' '}
                      </g>{' '}
                      <g id="Capa_1_216_"> </g>{' '}
                    </g>{' '}
                  </svg>
                </Tooltip>
              </a>
            </li>
            {/* {AdminRole == 0 && ( */}
            <li className="me-3">
              <div className="dropdown">
                <a
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="">
                    <Tooltip title="Settings" arrow>
                      {/* <img src='../../../assets/img/asset-tick.svg' /> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="24"
                        viewBox="0 0 20 20"
                      >
                        <path d="M11.078035,0 C11.3724371,0 11.6350302,0.183056678 11.7339285,0.457230801 L12.4396543,2.41370379 C12.6930786,2.47650967 12.9108093,2.54030436 13.0942558,2.60592238 C13.2952001,2.67779926 13.5540423,2.78741449 13.8746747,2.93586046 L15.5184936,2.06596774 C15.794148,1.92009416 16.1343396,1.97375545 16.3504064,2.19719235 L17.7960017,3.69209722 C17.98787,3.8905102 18.0422042,4.18265582 17.9342767,4.43557836 L17.162857,6.24336136 C17.2913496,6.47797752 17.3939318,6.67854463 17.4711247,6.84658462 C17.5553742,7.02998593 17.6588292,7.28241713 17.7829588,7.60671302 L19.580333,8.37623211 C19.8497082,8.4915611 20.0170118,8.76152727 19.9986241,9.05119919 L19.8669066,11.126215 C19.8494975,11.4004703 19.668825,11.6382294 19.4072566,11.7310995 L17.7049419,12.3355083 C17.6562729,12.5705675 17.6053791,12.772402 17.551477,12.9424906 C17.4883274,13.1417599 17.389065,13.3979932 17.2526724,13.7155635 L18.1084613,15.6068822 C18.2316885,15.879218 18.1635045,16.1990386 17.9395819,16.3990196 L16.3138559,17.8509252 C16.0957241,18.0457347 15.7773686,18.084139 15.5182641,17.9469002 L13.8421792,17.0591354 C13.5477413,17.2124998 13.2783109,17.3348831 13.0324612,17.4263047 C12.8127426,17.5080092 12.5685018,17.5992352 12.2997543,17.6999771 L11.6499659,19.5002547 C11.5529743,19.7689756 11.2984077,19.9507082 11.0099151,19.9571805 L9.10927684,20 C8.81300029,20.0064684 8.54492708,19.8269822 8.44118272,19.5525044 L7.6751041,17.5256808 C7.3232066,17.4026533 7.06612795,17.3070148 6.89898146,17.2366139 C6.74058527,17.1698987 6.53544077,17.0722593 6.28058727,16.9426265 L4.38190658,17.7549437 C4.12577479,17.8645252 3.82821583,17.812324 3.62584584,17.6223069 L2.22106797,16.3032781 C2.00593124,16.1012735 1.94386481,15.7866753 2.0664447,15.519534 L2.88322205,13.7395109 C2.76017205,13.4979963 2.65957084,13.2838441 2.58116863,13.0959926 C2.49857708,12.8981035 2.39862152,12.628586 2.28009144,12.2848943 L0.491710371,11.7412063 C0.190471763,11.6496264 -0.0110085834,11.3694211 0.000465944291,11.0580168 L0.071249487,9.13703967 C0.0806273232,8.88253689 0.2313194,8.65393727 0.463026654,8.5427144 L2.34096885,7.64127468 C2.42759746,7.32228988 2.50386559,7.07419005 2.57165467,6.89274074 C2.63878533,6.7130538 2.74293335,6.47740464 2.8854431,6.18143219 L2.06997455,4.45996626 C1.94312228,4.19217928 2.00336838,3.87420996 2.21965377,3.66998322 L3.62443163,2.34352648 C3.82439931,2.15470767 4.11840992,2.10075785 4.37358276,2.20606012 L6.27210909,2.98952564 C6.4823493,2.85093927 6.67247185,2.73658268 6.84371422,2.6461118 C7.04934485,2.53747289 7.3225817,2.42318736 7.66837893,2.29976859 L8.32789678,0.458652854 C8.42637398,0.183743082 8.68933933,0 8.98430143,0 L11.078035,0 Z M10.5870708,1.37705446 L9.47640909,1.37705446 L8.86948809,3.07134033 C8.79801391,3.27086827 8.63769115,3.42680114 8.43474473,3.49417973 C7.99915007,3.63879796 7.68401915,3.76347045 7.50006723,3.86065605 C7.30479682,3.96382144 7.05649639,4.12077045 6.75923344,4.33037214 C6.56321164,4.46858816 6.30888789,4.49688254 6.08670302,4.40519344 L4.25716409,3.65019697 L3.54351334,4.32405928 L4.2874951,5.89461557 C4.37724721,6.08408357 4.375001,6.30362324 4.2813906,6.49125715 C4.08134734,6.89222649 3.94589193,7.18842613 3.87809235,7.36990353 C3.8103478,7.55123365 3.71917424,7.8615808 3.60874921,8.29154274 C3.55823748,8.48822027 3.42255355,8.65285199 3.23793163,8.74147321 L1.44780841,9.60075854 L1.41171745,10.5802222 L3.03130231,11.0725942 C3.24698647,11.1381646 3.41716675,11.3030041 3.48790571,11.5148681 C3.64831871,11.9953067 3.7761118,12.3491471 3.86857839,12.5706968 C3.95934025,12.788162 4.09417527,13.0648832 4.27239921,13.3979523 C4.37321509,13.5863595 4.38009307,13.810311 4.29102495,14.0044194 L3.53951667,15.6421999 L4.25118794,16.3104301 L6.03251181,15.5483219 C6.22679544,15.465201 6.44877026,15.4739754 6.6357229,15.5721659 C7.00102332,15.7640277 7.27322021,15.8974495 7.44479999,15.9697176 C7.61953128,16.0433131 7.9548478,16.1653796 8.44065086,16.3314709 C8.63693275,16.3985778 8.7926767,16.548807 8.86538101,16.7411617 L9.57250939,18.6120199 L10.4993142,18.591227 L11.0961476,16.9376646 C11.1646975,16.747743 11.3140075,16.5970812 11.5046571,16.5254566 C11.8958011,16.3785088 12.2416349,16.2491584 12.5421977,16.1373911 C12.8039897,16.0400412 13.1223034,15.8867935 13.4934399,15.6776981 C13.7015148,15.5604703 13.9559143,15.5571841 14.1670155,15.6689972 L15.7439676,16.5042547 L16.6305025,15.7125069 L15.8561342,14.0011301 C15.7756691,13.8232999 15.7751619,13.6200892 15.8547382,13.4418685 C16.0370606,13.0335353 16.160351,12.7267619 16.2224704,12.5307434 C16.2832183,12.3390526 16.3456807,12.0622192 16.407072,11.7055024 C16.4492368,11.4605022 16.6216614,11.2569821 16.8582214,11.1729911 L18.5056035,10.5880863 L18.5779926,9.44770174 L16.9575114,8.75391676 C16.7827815,8.67910873 16.6466533,8.53682007 16.5808114,8.36016907 C16.4198441,7.92830106 16.2929314,7.61166725 16.2030747,7.41605965 C16.1143251,7.22286224 15.9738341,6.95669259 15.7830295,6.62172026 C15.677285,6.43607749 15.6644194,6.21248859 15.7481863,6.01618508 L16.4733058,4.31690418 L15.7093237,3.52686246 L14.2211258,4.31440213 C14.0242762,4.41857298 13.7888454,4.4230994 13.5880489,4.32657373 C13.1546705,4.11824271 12.829188,3.97550384 12.6204677,3.90084548 C12.4166956,3.82795707 12.1292655,3.75057315 11.7626377,3.671335 C11.5278825,3.62059807 11.3361711,3.45377367 11.2554479,3.22998614 L10.5870708,1.37705446 Z M10.0237083,5.64149212 C12.459442,5.64149212 14.4339942,7.59383168 14.4339942,10.0021646 C14.4339942,12.4104975 12.459442,14.362837 10.0237083,14.362837 C7.58797468,14.362837 5.61342244,12.4104975 5.61342244,10.0021646 C5.61342244,7.59383168 7.58797468,5.64149212 10.0237083,5.64149212 Z M10.0237083,7.01854658 C8.35715373,7.01854658 7.00614429,8.35435786 7.00614429,10.0021646 C7.00614429,11.6499713 8.35715373,12.9857826 10.0237083,12.9857826 C11.6902629,12.9857826 13.0412723,11.6499713 13.0412723,10.0021646 C13.0412723,8.35435786 11.6902629,7.01854658 10.0237083,7.01854658 Z" />
                      </svg>
                    </Tooltip>
                  </span>
                </a>
                <div className="dropdown-menu " aria-labelledby="dropdownMenuButton1">
                  <ul>
                    {/* {history.location.pathname !== "/templateupload" && ( */}
                    <li>
                      {templateUploadEnable == true && (
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            openTemplate();
                          }}
                        >
                          <span className="dropdown-icon fill">
                            {/* <svg
                                width="21"
                                height="16"
                                xmlns="http://www.w3.org/2000/svg"
                                id="Layer_1"
                                data-name="Layer 1"
                                viewBox="0 0 99.09 122.88"
                              >
                                <title>Template Upload</title>
                                <path d="M64.64,13,86.77,36.21H64.64V13ZM42.58,71.67a3.25,3.25,0,0,1-4.92-4.25l9.42-10.91a3.26,3.26,0,0,1,4.59-.33,5.14,5.14,0,0,1,.4.41l9.3,10.28a3.24,3.24,0,0,1-4.81,4.35L52.8,67.07V82.52a3.26,3.26,0,1,1-6.52,0V67.38l-3.7,4.29ZM24.22,85.42a3.26,3.26,0,1,1,6.52,0v7.46H68.36V85.42a3.26,3.26,0,1,1,6.51,0V96.14a3.26,3.26,0,0,1-3.26,3.26H27.48a3.26,3.26,0,0,1-3.26-3.26V85.42ZM99.08,39.19c.15-.57-1.18-2.07-2.68-3.56L63.8,1.36A3.63,3.63,0,0,0,61,0H6.62A6.62,6.62,0,0,0,0,6.62V116.26a6.62,6.62,0,0,0,6.62,6.62H92.46a6.62,6.62,0,0,0,6.62-6.62V39.19Zm-7.4,4.42v71.87H7.4V7.37H57.25V39.9A3.71,3.71,0,0,0,61,43.61Z" />
                              </svg> */}

                            <svg
                              width="21"
                              height="16"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {' '}
                              <title>Template Upload</title>
                              <g>
                                <path d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7zm9-10v7h-2V9H6l6-6 6 6h-5z"></path>
                              </g>
                            </svg>

                            {/* <svg
                              width="21"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.75 5.71429C3.26047 5.71429 2.86364 6.09804 2.86364 6.57143V11.7143C2.86364 12.1877 3.26047 12.5714 3.75 12.5714C4.23953 12.5714 4.63636 12.1877 4.63636 11.7143V6.57143C4.63636 6.09804 4.23953 5.71429 3.75 5.71429ZM6.11364 7.71429C6.11364 7.2409 6.51047 6.85714 7 6.85714C7.48952 6.85714 7.88636 7.2409 7.88636 7.71429V11.7143C7.88636 12.1877 7.48952 12.5714 7 12.5714C6.51047 12.5714 6.11364 12.1877 6.11364 11.7143V7.71429ZM10.25 9.14286C9.76048 9.14286 9.36364 9.52661 9.36364 10V11.7143C9.36364 12.1877 9.76048 12.5714 10.25 12.5714C10.7395 12.5714 11.1364 12.1877 11.1364 11.7143V10C11.1364 9.52661 10.7395 9.14286 10.25 9.14286ZM8.77273 0C9.54458 0 10.2012 0.477033 10.4446 1.14286H11.4318C12.574 1.14286 13.5 2.03829 13.5 3.14286V14C13.5 15.1046 12.574 16 11.4318 16H2.56818C1.42596 16 0.5 15.1046 0.5 14V3.14286C0.5 2.03829 1.42596 1.14286 2.56818 1.14286H3.55542C3.79877 0.477033 4.45542 0 5.22727 0H8.77273ZM5.22727 1.14286C4.90092 1.14286 4.63636 1.39869 4.63636 1.71429C4.63636 2.02988 4.90092 2.28571 5.22727 2.28571H8.77273C9.09908 2.28571 9.36364 2.02988 9.36364 1.71429C9.36364 1.39869 9.09908 1.14286 8.77273 1.14286H5.22727ZM2.56818 2.28571C2.07866 2.28571 1.68182 2.66947 1.68182 3.14286V14C1.68182 14.4734 2.07866 14.8571 2.56818 14.8571H11.4318C11.9213 14.8571 12.3182 14.4734 12.3182 14V3.14286C12.3182 2.66947 11.9213 2.28571 11.4318 2.28571H10.4446C10.2012 2.95154 9.54458 3.42857 8.77273 3.42857H5.22727C4.45542 3.42857 3.79877 2.95154 3.55542 2.28571H2.56818Z" />
                            </svg> */}
                          </span>
                          <span>Template Upload</span>
                        </a>
                      )}
                    </li>
                    {/* )} */}
                    {/* {history.location.pathname !== "/templatelist" && ( */}
                    <li>
                      {templateListEnable == true && (
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            openTemplatelist();
                          }}
                        >
                          <span className="dropdown-icon fill">
                            <svg
                              width="21"
                              height="16"
                              xmlns="http://www.w3.org/2000/svg"
                              id="Layer_1"
                              data-name="Layer 1"
                              viewBox="0 0 99.09 122.88"
                            >
                              <title>Template List</title>
                              <path d="M64.64,13,86.77,36.21H64.64V13ZM42.58,71.67a3.25,3.25,0,0,1-4.92-4.25l9.42-10.91a3.26,3.26,0,0,1,4.59-.33,5.14,5.14,0,0,1,.4.41l9.3,10.28a3.24,3.24,0,0,1-4.81,4.35L52.8,67.07V82.52a3.26,3.26,0,1,1-6.52,0V67.38l-3.7,4.29ZM24.22,85.42a3.26,3.26,0,1,1,6.52,0v7.46H68.36V85.42a3.26,3.26,0,1,1,6.51,0V96.14a3.26,3.26,0,0,1-3.26,3.26H27.48a3.26,3.26,0,0,1-3.26-3.26V85.42ZM99.08,39.19c.15-.57-1.18-2.07-2.68-3.56L63.8,1.36A3.63,3.63,0,0,0,61,0H6.62A6.62,6.62,0,0,0,0,6.62V116.26a6.62,6.62,0,0,0,6.62,6.62H92.46a6.62,6.62,0,0,0,6.62-6.62V39.19Zm-7.4,4.42v71.87H7.4V7.37H57.25V39.9A3.71,3.71,0,0,0,61,43.61Z" />
                            </svg>
                            {/* <svg
                              width="21"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.75 5.71429C3.26047 5.71429 2.86364 6.09804 2.86364 6.57143V11.7143C2.86364 12.1877 3.26047 12.5714 3.75 12.5714C4.23953 12.5714 4.63636 12.1877 4.63636 11.7143V6.57143C4.63636 6.09804 4.23953 5.71429 3.75 5.71429ZM6.11364 7.71429C6.11364 7.2409 6.51047 6.85714 7 6.85714C7.48952 6.85714 7.88636 7.2409 7.88636 7.71429V11.7143C7.88636 12.1877 7.48952 12.5714 7 12.5714C6.51047 12.5714 6.11364 12.1877 6.11364 11.7143V7.71429ZM10.25 9.14286C9.76048 9.14286 9.36364 9.52661 9.36364 10V11.7143C9.36364 12.1877 9.76048 12.5714 10.25 12.5714C10.7395 12.5714 11.1364 12.1877 11.1364 11.7143V10C11.1364 9.52661 10.7395 9.14286 10.25 9.14286ZM8.77273 0C9.54458 0 10.2012 0.477033 10.4446 1.14286H11.4318C12.574 1.14286 13.5 2.03829 13.5 3.14286V14C13.5 15.1046 12.574 16 11.4318 16H2.56818C1.42596 16 0.5 15.1046 0.5 14V3.14286C0.5 2.03829 1.42596 1.14286 2.56818 1.14286H3.55542C3.79877 0.477033 4.45542 0 5.22727 0H8.77273ZM5.22727 1.14286C4.90092 1.14286 4.63636 1.39869 4.63636 1.71429C4.63636 2.02988 4.90092 2.28571 5.22727 2.28571H8.77273C9.09908 2.28571 9.36364 2.02988 9.36364 1.71429C9.36364 1.39869 9.09908 1.14286 8.77273 1.14286H5.22727ZM2.56818 2.28571C2.07866 2.28571 1.68182 2.66947 1.68182 3.14286V14C1.68182 14.4734 2.07866 14.8571 2.56818 14.8571H11.4318C11.9213 14.8571 12.3182 14.4734 12.3182 14V3.14286C12.3182 2.66947 11.9213 2.28571 11.4318 2.28571H10.4446C10.2012 2.95154 9.54458 3.42857 8.77273 3.42857H5.22727C4.45542 3.42857 3.79877 2.95154 3.55542 2.28571H2.56818Z" />
                            </svg> */}
                          </span>
                          <span>Template List</span>
                        </a>
                      )}
                    </li>
                    {/* )} */}

                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          openRoleTable();
                        }}
                      >
                        <span className="dropdown-icon fill">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="16"
                            xlink="http://www.w3.org/1999/xlink"
                            version="1.1"
                            id="Capa_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 60 60"
                          >
                            <title>User Management</title>
                            <g>
                              <path d="M52.179,40.5l-5.596,8.04l-3.949-3.241c-0.426-0.352-1.057-0.287-1.407,0.138c-0.351,0.427-0.289,1.058,0.139,1.407   l4.786,3.929C46.331,50.921,46.556,51,46.786,51c0.045,0,0.091-0.003,0.137-0.01c0.276-0.038,0.524-0.19,0.684-0.419l6.214-8.929   c0.315-0.453,0.204-1.076-0.25-1.392C53.117,39.933,52.495,40.046,52.179,40.5z" />
                              <path d="M54.164,35.163C54.709,32.978,55,30.742,55,28.5C55,13.337,42.664,1,27.5,1S0,13.337,0,28.5   c0,8.01,3.444,15.229,8.927,20.259l-0.026,0.023l0.891,0.751c0.056,0.047,0.117,0.086,0.173,0.133   c0.477,0.396,0.972,0.772,1.476,1.136c0.159,0.115,0.318,0.23,0.479,0.341c0.535,0.369,1.085,0.719,1.646,1.051   c0.122,0.071,0.244,0.141,0.366,0.211c0.613,0.349,1.239,0.678,1.881,0.981c0.047,0.022,0.094,0.042,0.141,0.064   c2.089,0.971,4.319,1.684,6.65,2.105c0.062,0.011,0.123,0.022,0.185,0.033c0.723,0.125,1.455,0.225,2.197,0.292   c0.09,0.008,0.181,0.013,0.271,0.021C25.998,55.961,26.744,56,27.5,56c3.262,0,6.454-0.577,9.503-1.702   C39.389,57.168,42.984,59,47,59c7.168,0,13-5.832,13-13C60,41.478,57.677,37.492,54.164,35.163z M2,28.5C2,14.439,13.439,3,27.5,3   S53,14.439,53,28.5c0,1.903-0.214,3.804-0.639,5.666c-0.017-0.008-0.036-0.013-0.053-0.021c-0.376-0.169-0.762-0.32-1.156-0.453   c-0.034-0.011-0.067-0.026-0.101-0.037c-0.411-0.135-0.83-0.251-1.258-0.345c-0.02-0.005-0.04-0.011-0.06-0.016   c-0.417-0.09-0.841-0.158-1.271-0.207c-0.03-0.004-0.06-0.01-0.09-0.014C47.921,33.027,47.464,33,47,33   c-5.923,0-10.923,3.986-12.485,9.413C34.077,42,33.818,41.425,33.818,40.8v-2.957c0.198-0.243,0.405-0.518,0.617-0.817   c1.096-1.547,1.975-3.269,2.616-5.123c1.266-0.602,2.085-1.864,2.085-3.289v-3.545c0-0.866-0.318-1.708-0.886-2.369v-4.667   c0.052-0.52,0.236-3.448-1.883-5.864C34.524,10.065,31.541,9,27.5,9s-7.024,1.065-8.867,3.168   c-2.119,2.416-1.935,5.346-1.883,5.864v4.667c-0.568,0.661-0.886,1.503-0.886,2.369v3.545c0,1.101,0.494,2.128,1.339,2.821   c0.81,3.173,2.476,5.575,3.092,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313c-0.253,0.138-0.502,0.298-0.752,0.477   C5.276,42.792,2,36.022,2,28.5z M25.605,53.922c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.266-0.131-1.893-0.234   c-0.026-0.004-0.052-0.01-0.077-0.014c-1.327-0.222-2.632-0.548-3.903-0.974c-0.034-0.011-0.068-0.023-0.102-0.035   c-1.237-0.42-2.44-0.939-3.601-1.544c-0.067-0.035-0.135-0.068-0.201-0.103c-0.515-0.275-1.019-0.573-1.515-0.883   c-0.143-0.09-0.284-0.181-0.425-0.273c-0.456-0.298-0.905-0.608-1.343-0.936c-0.045-0.034-0.088-0.07-0.133-0.104   c0.032-0.018,0.064-0.036,0.097-0.054l7.907-4.313c1.359-0.742,2.204-2.165,2.204-3.714v-3.603l-0.233-0.278   c-0.021-0.025-2.176-2.634-2.999-6.215l-0.091-0.396l-0.341-0.221c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545   c0-0.465,0.198-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131c-0.003-0.024-0.298-2.429,1.396-4.36   C21.583,11.837,24.06,11,27.5,11c3.425,0,5.897,0.83,7.346,2.466c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298   c0.359,0.324,0.557,0.758,0.557,1.223v3.545c0,0.724-0.475,1.356-1.181,1.574l-0.498,0.154l-0.16,0.496   c-0.589,1.833-1.429,3.525-2.496,5.032c-0.259,0.367-0.514,0.695-0.736,0.948l-0.248,0.283V40.8c0,1.587,0.868,3.015,2.268,3.746   C34.033,45.024,34,45.508,34,46c0,0.292,0.01,0.583,0.029,0.873c0.007,0.103,0.021,0.205,0.031,0.307   c0.009,0.096,0.018,0.191,0.029,0.287c0.01,0.09,0.015,0.181,0.027,0.27c0.023,0.17,0.056,0.338,0.086,0.507   c0.02,0.115,0.035,0.231,0.058,0.345c0,0,0.002,0.008,0.003,0.012c0.006,0.03,0.015,0.058,0.021,0.088   c0.031,0.146,0.068,0.291,0.104,0.436c0.025,0.101,0.045,0.202,0.072,0.302c0.024,0.088,0.055,0.173,0.081,0.26   c0.034,0.116,0.07,0.231,0.108,0.345c0.024,0.072,0.042,0.145,0.067,0.216c0.07,0.201,0.15,0.399,0.23,0.596   c0.001,0.003,0.002,0.005,0.003,0.008c0.061,0.15,0.125,0.297,0.191,0.444c0.049,0.109,0.1,0.218,0.152,0.326   c0.034,0.071,0.064,0.143,0.099,0.213c0.023,0.046,0.05,0.09,0.074,0.136c0.084,0.163,0.173,0.322,0.264,0.48   c0.027,0.047,0.051,0.096,0.078,0.143C33.119,53.527,30.33,54,27.5,54C26.866,54,26.234,53.969,25.605,53.922z M47,57   c-3.661,0-6.901-1.805-8.902-4.564c-0.083-0.114-0.158-0.231-0.236-0.347c-0.054-0.08-0.111-0.158-0.162-0.239   c-0.043-0.069-0.085-0.138-0.127-0.208c-0.045-0.074-0.085-0.15-0.128-0.225c-0.069-0.122-0.143-0.241-0.207-0.365   c-0.047-0.091-0.089-0.185-0.134-0.278c-0.012-0.025-0.023-0.051-0.035-0.076c-0.075-0.157-0.153-0.312-0.221-0.472   c-0.036-0.085-0.063-0.173-0.097-0.258c-0.077-0.199-0.155-0.398-0.221-0.602c-0.031-0.095-0.055-0.193-0.083-0.289   c-0.009-0.03-0.017-0.059-0.025-0.088c-0.056-0.199-0.11-0.399-0.155-0.603c-0.014-0.063-0.025-0.127-0.038-0.191   c-0.012-0.06-0.025-0.121-0.036-0.181c-0.041-0.222-0.075-0.446-0.103-0.672c-0.003-0.026-0.006-0.052-0.009-0.079   c-0.009-0.082-0.022-0.164-0.029-0.246C36.021,46.681,36,46.343,36,46c0-0.315,0.021-0.626,0.047-0.934   c0.028-0.295,0.067-0.599,0.122-0.919l0.074-0.433C37.298,38.742,41.719,35,47,35c0.446,0,0.89,0.034,1.332,0.089   c0.101,0.012,0.199,0.031,0.299,0.046c0.365,0.055,0.728,0.127,1.086,0.219c0.075,0.019,0.15,0.037,0.225,0.058   c0.882,0.247,1.735,0.601,2.537,1.063C55.773,38.377,58,41.93,58,46C58,52.065,53.065,57,47,57z" />
                            </g>
                          </svg>
                          {/* <svg
                              width="21"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.75 5.71429C3.26047 5.71429 2.86364 6.09804 2.86364 6.57143V11.7143C2.86364 12.1877 3.26047 12.5714 3.75 12.5714C4.23953 12.5714 4.63636 12.1877 4.63636 11.7143V6.57143C4.63636 6.09804 4.23953 5.71429 3.75 5.71429ZM6.11364 7.71429C6.11364 7.2409 6.51047 6.85714 7 6.85714C7.48952 6.85714 7.88636 7.2409 7.88636 7.71429V11.7143C7.88636 12.1877 7.48952 12.5714 7 12.5714C6.51047 12.5714 6.11364 12.1877 6.11364 11.7143V7.71429ZM10.25 9.14286C9.76048 9.14286 9.36364 9.52661 9.36364 10V11.7143C9.36364 12.1877 9.76048 12.5714 10.25 12.5714C10.7395 12.5714 11.1364 12.1877 11.1364 11.7143V10C11.1364 9.52661 10.7395 9.14286 10.25 9.14286ZM8.77273 0C9.54458 0 10.2012 0.477033 10.4446 1.14286H11.4318C12.574 1.14286 13.5 2.03829 13.5 3.14286V14C13.5 15.1046 12.574 16 11.4318 16H2.56818C1.42596 16 0.5 15.1046 0.5 14V3.14286C0.5 2.03829 1.42596 1.14286 2.56818 1.14286H3.55542C3.79877 0.477033 4.45542 0 5.22727 0H8.77273ZM5.22727 1.14286C4.90092 1.14286 4.63636 1.39869 4.63636 1.71429C4.63636 2.02988 4.90092 2.28571 5.22727 2.28571H8.77273C9.09908 2.28571 9.36364 2.02988 9.36364 1.71429C9.36364 1.39869 9.09908 1.14286 8.77273 1.14286H5.22727ZM2.56818 2.28571C2.07866 2.28571 1.68182 2.66947 1.68182 3.14286V14C1.68182 14.4734 2.07866 14.8571 2.56818 14.8571H11.4318C11.9213 14.8571 12.3182 14.4734 12.3182 14V3.14286C12.3182 2.66947 11.9213 2.28571 11.4318 2.28571H10.4446C10.2012 2.95154 9.54458 3.42857 8.77273 3.42857H5.22727C4.45542 3.42857 3.79877 2.95154 3.55542 2.28571H2.56818Z" />
                            </svg> */}
                        </span>
                        <span>User Management</span>
                      </a>
                    </li>
                    {/* <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            openOrgDashbaord();
                          }}
                        >
                          <span className="dropdown-icon fill">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21"
                              height="16" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 60 60">
                              <g>
                                <path d="M52.179,40.5l-5.596,8.04l-3.949-3.241c-0.426-0.352-1.057-0.287-1.407,0.138c-0.351,0.427-0.289,1.058,0.139,1.407   l4.786,3.929C46.331,50.921,46.556,51,46.786,51c0.045,0,0.091-0.003,0.137-0.01c0.276-0.038,0.524-0.19,0.684-0.419l6.214-8.929   c0.315-0.453,0.204-1.076-0.25-1.392C53.117,39.933,52.495,40.046,52.179,40.5z" />
                                <path d="M54.164,35.163C54.709,32.978,55,30.742,55,28.5C55,13.337,42.664,1,27.5,1S0,13.337,0,28.5   c0,8.01,3.444,15.229,8.927,20.259l-0.026,0.023l0.891,0.751c0.056,0.047,0.117,0.086,0.173,0.133   c0.477,0.396,0.972,0.772,1.476,1.136c0.159,0.115,0.318,0.23,0.479,0.341c0.535,0.369,1.085,0.719,1.646,1.051   c0.122,0.071,0.244,0.141,0.366,0.211c0.613,0.349,1.239,0.678,1.881,0.981c0.047,0.022,0.094,0.042,0.141,0.064   c2.089,0.971,4.319,1.684,6.65,2.105c0.062,0.011,0.123,0.022,0.185,0.033c0.723,0.125,1.455,0.225,2.197,0.292   c0.09,0.008,0.181,0.013,0.271,0.021C25.998,55.961,26.744,56,27.5,56c3.262,0,6.454-0.577,9.503-1.702   C39.389,57.168,42.984,59,47,59c7.168,0,13-5.832,13-13C60,41.478,57.677,37.492,54.164,35.163z M2,28.5C2,14.439,13.439,3,27.5,3   S53,14.439,53,28.5c0,1.903-0.214,3.804-0.639,5.666c-0.017-0.008-0.036-0.013-0.053-0.021c-0.376-0.169-0.762-0.32-1.156-0.453   c-0.034-0.011-0.067-0.026-0.101-0.037c-0.411-0.135-0.83-0.251-1.258-0.345c-0.02-0.005-0.04-0.011-0.06-0.016   c-0.417-0.09-0.841-0.158-1.271-0.207c-0.03-0.004-0.06-0.01-0.09-0.014C47.921,33.027,47.464,33,47,33   c-5.923,0-10.923,3.986-12.485,9.413C34.077,42,33.818,41.425,33.818,40.8v-2.957c0.198-0.243,0.405-0.518,0.617-0.817   c1.096-1.547,1.975-3.269,2.616-5.123c1.266-0.602,2.085-1.864,2.085-3.289v-3.545c0-0.866-0.318-1.708-0.886-2.369v-4.667   c0.052-0.52,0.236-3.448-1.883-5.864C34.524,10.065,31.541,9,27.5,9s-7.024,1.065-8.867,3.168   c-2.119,2.416-1.935,5.346-1.883,5.864v4.667c-0.568,0.661-0.886,1.503-0.886,2.369v3.545c0,1.101,0.494,2.128,1.339,2.821   c0.81,3.173,2.476,5.575,3.092,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313c-0.253,0.138-0.502,0.298-0.752,0.477   C5.276,42.792,2,36.022,2,28.5z M25.605,53.922c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.266-0.131-1.893-0.234   c-0.026-0.004-0.052-0.01-0.077-0.014c-1.327-0.222-2.632-0.548-3.903-0.974c-0.034-0.011-0.068-0.023-0.102-0.035   c-1.237-0.42-2.44-0.939-3.601-1.544c-0.067-0.035-0.135-0.068-0.201-0.103c-0.515-0.275-1.019-0.573-1.515-0.883   c-0.143-0.09-0.284-0.181-0.425-0.273c-0.456-0.298-0.905-0.608-1.343-0.936c-0.045-0.034-0.088-0.07-0.133-0.104   c0.032-0.018,0.064-0.036,0.097-0.054l7.907-4.313c1.359-0.742,2.204-2.165,2.204-3.714v-3.603l-0.233-0.278   c-0.021-0.025-2.176-2.634-2.999-6.215l-0.091-0.396l-0.341-0.221c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545   c0-0.465,0.198-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131c-0.003-0.024-0.298-2.429,1.396-4.36   C21.583,11.837,24.06,11,27.5,11c3.425,0,5.897,0.83,7.346,2.466c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298   c0.359,0.324,0.557,0.758,0.557,1.223v3.545c0,0.724-0.475,1.356-1.181,1.574l-0.498,0.154l-0.16,0.496   c-0.589,1.833-1.429,3.525-2.496,5.032c-0.259,0.367-0.514,0.695-0.736,0.948l-0.248,0.283V40.8c0,1.587,0.868,3.015,2.268,3.746   C34.033,45.024,34,45.508,34,46c0,0.292,0.01,0.583,0.029,0.873c0.007,0.103,0.021,0.205,0.031,0.307   c0.009,0.096,0.018,0.191,0.029,0.287c0.01,0.09,0.015,0.181,0.027,0.27c0.023,0.17,0.056,0.338,0.086,0.507   c0.02,0.115,0.035,0.231,0.058,0.345c0,0,0.002,0.008,0.003,0.012c0.006,0.03,0.015,0.058,0.021,0.088   c0.031,0.146,0.068,0.291,0.104,0.436c0.025,0.101,0.045,0.202,0.072,0.302c0.024,0.088,0.055,0.173,0.081,0.26   c0.034,0.116,0.07,0.231,0.108,0.345c0.024,0.072,0.042,0.145,0.067,0.216c0.07,0.201,0.15,0.399,0.23,0.596   c0.001,0.003,0.002,0.005,0.003,0.008c0.061,0.15,0.125,0.297,0.191,0.444c0.049,0.109,0.1,0.218,0.152,0.326   c0.034,0.071,0.064,0.143,0.099,0.213c0.023,0.046,0.05,0.09,0.074,0.136c0.084,0.163,0.173,0.322,0.264,0.48   c0.027,0.047,0.051,0.096,0.078,0.143C33.119,53.527,30.33,54,27.5,54C26.866,54,26.234,53.969,25.605,53.922z M47,57   c-3.661,0-6.901-1.805-8.902-4.564c-0.083-0.114-0.158-0.231-0.236-0.347c-0.054-0.08-0.111-0.158-0.162-0.239   c-0.043-0.069-0.085-0.138-0.127-0.208c-0.045-0.074-0.085-0.15-0.128-0.225c-0.069-0.122-0.143-0.241-0.207-0.365   c-0.047-0.091-0.089-0.185-0.134-0.278c-0.012-0.025-0.023-0.051-0.035-0.076c-0.075-0.157-0.153-0.312-0.221-0.472   c-0.036-0.085-0.063-0.173-0.097-0.258c-0.077-0.199-0.155-0.398-0.221-0.602c-0.031-0.095-0.055-0.193-0.083-0.289   c-0.009-0.03-0.017-0.059-0.025-0.088c-0.056-0.199-0.11-0.399-0.155-0.603c-0.014-0.063-0.025-0.127-0.038-0.191   c-0.012-0.06-0.025-0.121-0.036-0.181c-0.041-0.222-0.075-0.446-0.103-0.672c-0.003-0.026-0.006-0.052-0.009-0.079   c-0.009-0.082-0.022-0.164-0.029-0.246C36.021,46.681,36,46.343,36,46c0-0.315,0.021-0.626,0.047-0.934   c0.028-0.295,0.067-0.599,0.122-0.919l0.074-0.433C37.298,38.742,41.719,35,47,35c0.446,0,0.89,0.034,1.332,0.089   c0.101,0.012,0.199,0.031,0.299,0.046c0.365,0.055,0.728,0.127,1.086,0.219c0.075,0.019,0.15,0.037,0.225,0.058   c0.882,0.247,1.735,0.601,2.537,1.063C55.773,38.377,58,41.93,58,46C58,52.065,53.065,57,47,57z" />
                              </g>

                            </svg>

                          </span>
                          <span>Org Dashboard</span>
                        </a>
                      </li>
                      */}
                    <li>
                      <Link className="dropdown-item" to="/repository-management">
                        <span className="dropdown-icon fill">
                          <svg
                            width="21"
                            height="19"
                            viewBox="0 0 21 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <title>Repository Management</title>
                            <path
                              d="M12.0162 18.3333H8.98286C8.59129 18.3333 8.25249 18.0608 8.16869 17.6783L7.82953 16.1083C7.37707 15.9101 6.94805 15.6621 6.55036 15.3691L5.01953 15.8566C4.64619 15.9757 4.24035 15.8185 4.04453 15.4791L2.52453 12.8533C2.33085 12.5137 2.39757 12.0854 2.68536 11.8208L3.87286 10.7375C3.81886 10.2467 3.81886 9.75153 3.87286 9.26079L2.68536 8.17996C2.39715 7.91527 2.3304 7.48639 2.52453 7.14663L4.04119 4.51913C4.23701 4.17971 4.64286 4.02257 5.01619 4.14163L6.54703 4.62913C6.75041 4.47842 6.96214 4.33931 7.18119 4.21246C7.39148 4.09387 7.60789 3.9865 7.82953 3.89079L8.16953 2.32246C8.25292 1.93993 8.59135 1.66704 8.98286 1.66663H12.0162C12.4077 1.66704 12.7461 1.93993 12.8295 2.32246L13.1729 3.89163C13.4068 3.99456 13.6347 4.11086 13.8554 4.23996C14.0611 4.35897 14.2601 4.48945 14.4512 4.63079L15.9829 4.14329C16.3559 4.02468 16.7613 4.18176 16.957 4.52079L18.4737 7.14829C18.6674 7.48786 18.6006 7.91622 18.3129 8.18079L17.1254 9.26413C17.1794 9.75487 17.1794 10.2501 17.1254 10.7408L18.3129 11.8241C18.6006 12.0887 18.6674 12.5171 18.4737 12.8566L16.957 15.4841C16.7613 15.8232 16.3559 15.9802 15.9829 15.8616L14.4512 15.3741C14.2574 15.5169 14.056 15.649 13.8479 15.77C13.6294 15.8965 13.404 16.0109 13.1729 16.1125L12.8295 17.6783C12.7458 18.0605 12.4075 18.333 12.0162 18.3333ZM6.84953 13.5241L7.53286 14.0241C7.6869 14.1376 7.84745 14.2419 8.01369 14.3366C8.17011 14.4272 8.33116 14.5095 8.49619 14.5833L9.27369 14.9241L9.65453 16.6666H11.3462L11.727 14.9233L12.5045 14.5825C12.8439 14.4328 13.1661 14.2467 13.4654 14.0275L14.1495 13.5275L15.8504 14.0691L16.6962 12.6041L15.377 11.4016L15.4704 10.5583C15.5114 10.1894 15.5114 9.81716 15.4704 9.44829L15.377 8.60496L16.697 7.39996L15.8504 5.93413L14.1495 6.47579L13.4654 5.97579C13.166 5.75555 12.8439 5.56809 12.5045 5.41663L11.727 5.07579L11.3462 3.33329H9.65453L9.27203 5.07663L8.49619 5.41663C8.33103 5.48916 8.16996 5.57067 8.01369 5.66079C7.84847 5.75523 7.68877 5.85901 7.53536 5.97163L6.85119 6.47163L5.15119 5.92996L4.30369 7.39996L5.62286 8.60079L5.52953 9.44496C5.48853 9.81382 5.48853 10.1861 5.52953 10.555L5.62286 11.3983L4.30369 12.6008L5.14953 14.0658L6.84953 13.5241ZM10.4962 13.3333C8.65524 13.3333 7.16286 11.8409 7.16286 9.99996C7.16286 8.15901 8.65524 6.66663 10.4962 6.66663C12.3371 6.66663 13.8295 8.15901 13.8295 9.99996C13.8272 11.84 12.3362 13.331 10.4962 13.3333ZM10.4962 8.33329C9.58569 8.33422 8.84443 9.06567 8.83139 9.97608C8.81834 10.8865 9.53833 11.6389 10.4484 11.6659C11.3585 11.6929 12.1219 10.9845 12.1629 10.075V10.4083V9.99996C12.1629 9.07948 11.4167 8.33329 10.4962 8.33329Z"
                              fill=""
                            />
                          </svg>
                        </span>
                        <span>Repository Management</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/render-list">
                        <span className="dropdown-icon fill">
                          <svg
                            width="21"
                            height="16"
                            xmlns="http://www.w3.org/2000/svg"
                            id="Layer_1"
                            data-name="Layer 1"
                            viewBox="0 0 99.09 122.88"
                          >
                            <title>Render List</title>
                            <path d="M64.64,13,86.77,36.21H64.64V13ZM42.58,71.67a3.25,3.25,0,0,1-4.92-4.25l9.42-10.91a3.26,3.26,0,0,1,4.59-.33,5.14,5.14,0,0,1,.4.41l9.3,10.28a3.24,3.24,0,0,1-4.81,4.35L52.8,67.07V82.52a3.26,3.26,0,1,1-6.52,0V67.38l-3.7,4.29ZM24.22,85.42a3.26,3.26,0,1,1,6.52,0v7.46H68.36V85.42a3.26,3.26,0,1,1,6.51,0V96.14a3.26,3.26,0,0,1-3.26,3.26H27.48a3.26,3.26,0,0,1-3.26-3.26V85.42ZM99.08,39.19c.15-.57-1.18-2.07-2.68-3.56L63.8,1.36A3.63,3.63,0,0,0,61,0H6.62A6.62,6.62,0,0,0,0,6.62V116.26a6.62,6.62,0,0,0,6.62,6.62H92.46a6.62,6.62,0,0,0,6.62-6.62V39.19Zm-7.4,4.42v71.87H7.4V7.37H57.25V39.9A3.71,3.71,0,0,0,61,43.61Z" />
                          </svg>
                        </span>
                        <span>Render List</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            {/* )} */}
            {userParentId == '' && (
              <li className="me-3">
                <div className="dropdown">
                  <a
                    className=" dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="">
                      <Tooltip title="Super Admin" arrow>
                        {/* <img src='../../../assets/img/asset-tick.svg' /> */}
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 20 20">
                          <path  d="M11.078035,0 C11.3724371,0 11.6350302,0.183056678 11.7339285,0.457230801 L12.4396543,2.41370379 C12.6930786,2.47650967 12.9108093,2.54030436 13.0942558,2.60592238 C13.2952001,2.67779926 13.5540423,2.78741449 13.8746747,2.93586046 L15.5184936,2.06596774 C15.794148,1.92009416 16.1343396,1.97375545 16.3504064,2.19719235 L17.7960017,3.69209722 C17.98787,3.8905102 18.0422042,4.18265582 17.9342767,4.43557836 L17.162857,6.24336136 C17.2913496,6.47797752 17.3939318,6.67854463 17.4711247,6.84658462 C17.5553742,7.02998593 17.6588292,7.28241713 17.7829588,7.60671302 L19.580333,8.37623211 C19.8497082,8.4915611 20.0170118,8.76152727 19.9986241,9.05119919 L19.8669066,11.126215 C19.8494975,11.4004703 19.668825,11.6382294 19.4072566,11.7310995 L17.7049419,12.3355083 C17.6562729,12.5705675 17.6053791,12.772402 17.551477,12.9424906 C17.4883274,13.1417599 17.389065,13.3979932 17.2526724,13.7155635 L18.1084613,15.6068822 C18.2316885,15.879218 18.1635045,16.1990386 17.9395819,16.3990196 L16.3138559,17.8509252 C16.0957241,18.0457347 15.7773686,18.084139 15.5182641,17.9469002 L13.8421792,17.0591354 C13.5477413,17.2124998 13.2783109,17.3348831 13.0324612,17.4263047 C12.8127426,17.5080092 12.5685018,17.5992352 12.2997543,17.6999771 L11.6499659,19.5002547 C11.5529743,19.7689756 11.2984077,19.9507082 11.0099151,19.9571805 L9.10927684,20 C8.81300029,20.0064684 8.54492708,19.8269822 8.44118272,19.5525044 L7.6751041,17.5256808 C7.3232066,17.4026533 7.06612795,17.3070148 6.89898146,17.2366139 C6.74058527,17.1698987 6.53544077,17.0722593 6.28058727,16.9426265 L4.38190658,17.7549437 C4.12577479,17.8645252 3.82821583,17.812324 3.62584584,17.6223069 L2.22106797,16.3032781 C2.00593124,16.1012735 1.94386481,15.7866753 2.0664447,15.519534 L2.88322205,13.7395109 C2.76017205,13.4979963 2.65957084,13.2838441 2.58116863,13.0959926 C2.49857708,12.8981035 2.39862152,12.628586 2.28009144,12.2848943 L0.491710371,11.7412063 C0.190471763,11.6496264 -0.0110085834,11.3694211 0.000465944291,11.0580168 L0.071249487,9.13703967 C0.0806273232,8.88253689 0.2313194,8.65393727 0.463026654,8.5427144 L2.34096885,7.64127468 C2.42759746,7.32228988 2.50386559,7.07419005 2.57165467,6.89274074 C2.63878533,6.7130538 2.74293335,6.47740464 2.8854431,6.18143219 L2.06997455,4.45996626 C1.94312228,4.19217928 2.00336838,3.87420996 2.21965377,3.66998322 L3.62443163,2.34352648 C3.82439931,2.15470767 4.11840992,2.10075785 4.37358276,2.20606012 L6.27210909,2.98952564 C6.4823493,2.85093927 6.67247185,2.73658268 6.84371422,2.6461118 C7.04934485,2.53747289 7.3225817,2.42318736 7.66837893,2.29976859 L8.32789678,0.458652854 C8.42637398,0.183743082 8.68933933,0 8.98430143,0 L11.078035,0 Z M10.5870708,1.37705446 L9.47640909,1.37705446 L8.86948809,3.07134033 C8.79801391,3.27086827 8.63769115,3.42680114 8.43474473,3.49417973 C7.99915007,3.63879796 7.68401915,3.76347045 7.50006723,3.86065605 C7.30479682,3.96382144 7.05649639,4.12077045 6.75923344,4.33037214 C6.56321164,4.46858816 6.30888789,4.49688254 6.08670302,4.40519344 L4.25716409,3.65019697 L3.54351334,4.32405928 L4.2874951,5.89461557 C4.37724721,6.08408357 4.375001,6.30362324 4.2813906,6.49125715 C4.08134734,6.89222649 3.94589193,7.18842613 3.87809235,7.36990353 C3.8103478,7.55123365 3.71917424,7.8615808 3.60874921,8.29154274 C3.55823748,8.48822027 3.42255355,8.65285199 3.23793163,8.74147321 L1.44780841,9.60075854 L1.41171745,10.5802222 L3.03130231,11.0725942 C3.24698647,11.1381646 3.41716675,11.3030041 3.48790571,11.5148681 C3.64831871,11.9953067 3.7761118,12.3491471 3.86857839,12.5706968 C3.95934025,12.788162 4.09417527,13.0648832 4.27239921,13.3979523 C4.37321509,13.5863595 4.38009307,13.810311 4.29102495,14.0044194 L3.53951667,15.6421999 L4.25118794,16.3104301 L6.03251181,15.5483219 C6.22679544,15.465201 6.44877026,15.4739754 6.6357229,15.5721659 C7.00102332,15.7640277 7.27322021,15.8974495 7.44479999,15.9697176 C7.61953128,16.0433131 7.9548478,16.1653796 8.44065086,16.3314709 C8.63693275,16.3985778 8.7926767,16.548807 8.86538101,16.7411617 L9.57250939,18.6120199 L10.4993142,18.591227 L11.0961476,16.9376646 C11.1646975,16.747743 11.3140075,16.5970812 11.5046571,16.5254566 C11.8958011,16.3785088 12.2416349,16.2491584 12.5421977,16.1373911 C12.8039897,16.0400412 13.1223034,15.8867935 13.4934399,15.6776981 C13.7015148,15.5604703 13.9559143,15.5571841 14.1670155,15.6689972 L15.7439676,16.5042547 L16.6305025,15.7125069 L15.8561342,14.0011301 C15.7756691,13.8232999 15.7751619,13.6200892 15.8547382,13.4418685 C16.0370606,13.0335353 16.160351,12.7267619 16.2224704,12.5307434 C16.2832183,12.3390526 16.3456807,12.0622192 16.407072,11.7055024 C16.4492368,11.4605022 16.6216614,11.2569821 16.8582214,11.1729911 L18.5056035,10.5880863 L18.5779926,9.44770174 L16.9575114,8.75391676 C16.7827815,8.67910873 16.6466533,8.53682007 16.5808114,8.36016907 C16.4198441,7.92830106 16.2929314,7.61166725 16.2030747,7.41605965 C16.1143251,7.22286224 15.9738341,6.95669259 15.7830295,6.62172026 C15.677285,6.43607749 15.6644194,6.21248859 15.7481863,6.01618508 L16.4733058,4.31690418 L15.7093237,3.52686246 L14.2211258,4.31440213 C14.0242762,4.41857298 13.7888454,4.4230994 13.5880489,4.32657373 C13.1546705,4.11824271 12.829188,3.97550384 12.6204677,3.90084548 C12.4166956,3.82795707 12.1292655,3.75057315 11.7626377,3.671335 C11.5278825,3.62059807 11.3361711,3.45377367 11.2554479,3.22998614 L10.5870708,1.37705446 Z M10.0237083,5.64149212 C12.459442,5.64149212 14.4339942,7.59383168 14.4339942,10.0021646 C14.4339942,12.4104975 12.459442,14.362837 10.0237083,14.362837 C7.58797468,14.362837 5.61342244,12.4104975 5.61342244,10.0021646 C5.61342244,7.59383168 7.58797468,5.64149212 10.0237083,5.64149212 Z M10.0237083,7.01854658 C8.35715373,7.01854658 7.00614429,8.35435786 7.00614429,10.0021646 C7.00614429,11.6499713 8.35715373,12.9857826 10.0237083,12.9857826 C11.6902629,12.9857826 13.0412723,11.6499713 13.0412723,10.0021646 C13.0412723,8.35435786 11.6902629,7.01854658 10.0237083,7.01854658 Z" />
                        </svg> */}
                        <svg
                          fill=""
                          height="22"
                          width="24"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          enable-background="new 0 0 24 24"
                        >
                          <g id="user-admin">
                            <path
                              d="M22.3,16.7l1.4-1.4L20,11.6l-5.8,5.8c-0.5-0.3-1.1-0.4-1.7-0.4C10.6,17,9,18.6,9,20.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5
        c0-0.6-0.2-1.2-0.4-1.7l1.9-1.9l2.3,2.3l1.4-1.4l-2.3-2.3l1.1-1.1L22.3,16.7z M12.5,22c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5
        s1.5,0.7,1.5,1.5S13.3,22,12.5,22z"
                            />
                            <path
                              d="M2,19c0-3.9,3.1-7,7-7c2,0,3.9,0.9,5.3,2.4l1.5-1.3c-0.9-1-1.9-1.8-3.1-2.3C14.1,9.7,15,7.9,15,6c0-3.3-2.7-6-6-6
        S3,2.7,3,6c0,1.9,0.9,3.7,2.4,4.8C2.2,12.2,0,15.3,0,19v5h8v-2H2V19z M5,6c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S5,8.2,5,6z"
                            />
                          </g>
                        </svg>
                      </Tooltip>
                    </span>
                  </a>
                  <div className="dropdown-menu " aria-labelledby="dropdownMenuButton1">
                    {AdminRole == 0 && (
                      <ul>
                        {/* {history.location.pathname !==
                        "/admin/config-settings" && ( */}
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              configSettings();
                            }}
                          >
                            <Tooltip title="Config Settings" arrow>
                              <span className="dropdown-icon fill">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="16"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M11.078035,0 C11.3724371,0 11.6350302,0.183056678 11.7339285,0.457230801 L12.4396543,2.41370379 C12.6930786,2.47650967 12.9108093,2.54030436 13.0942558,2.60592238 C13.2952001,2.67779926 13.5540423,2.78741449 13.8746747,2.93586046 L15.5184936,2.06596774 C15.794148,1.92009416 16.1343396,1.97375545 16.3504064,2.19719235 L17.7960017,3.69209722 C17.98787,3.8905102 18.0422042,4.18265582 17.9342767,4.43557836 L17.162857,6.24336136 C17.2913496,6.47797752 17.3939318,6.67854463 17.4711247,6.84658462 C17.5553742,7.02998593 17.6588292,7.28241713 17.7829588,7.60671302 L19.580333,8.37623211 C19.8497082,8.4915611 20.0170118,8.76152727 19.9986241,9.05119919 L19.8669066,11.126215 C19.8494975,11.4004703 19.668825,11.6382294 19.4072566,11.7310995 L17.7049419,12.3355083 C17.6562729,12.5705675 17.6053791,12.772402 17.551477,12.9424906 C17.4883274,13.1417599 17.389065,13.3979932 17.2526724,13.7155635 L18.1084613,15.6068822 C18.2316885,15.879218 18.1635045,16.1990386 17.9395819,16.3990196 L16.3138559,17.8509252 C16.0957241,18.0457347 15.7773686,18.084139 15.5182641,17.9469002 L13.8421792,17.0591354 C13.5477413,17.2124998 13.2783109,17.3348831 13.0324612,17.4263047 C12.8127426,17.5080092 12.5685018,17.5992352 12.2997543,17.6999771 L11.6499659,19.5002547 C11.5529743,19.7689756 11.2984077,19.9507082 11.0099151,19.9571805 L9.10927684,20 C8.81300029,20.0064684 8.54492708,19.8269822 8.44118272,19.5525044 L7.6751041,17.5256808 C7.3232066,17.4026533 7.06612795,17.3070148 6.89898146,17.2366139 C6.74058527,17.1698987 6.53544077,17.0722593 6.28058727,16.9426265 L4.38190658,17.7549437 C4.12577479,17.8645252 3.82821583,17.812324 3.62584584,17.6223069 L2.22106797,16.3032781 C2.00593124,16.1012735 1.94386481,15.7866753 2.0664447,15.519534 L2.88322205,13.7395109 C2.76017205,13.4979963 2.65957084,13.2838441 2.58116863,13.0959926 C2.49857708,12.8981035 2.39862152,12.628586 2.28009144,12.2848943 L0.491710371,11.7412063 C0.190471763,11.6496264 -0.0110085834,11.3694211 0.000465944291,11.0580168 L0.071249487,9.13703967 C0.0806273232,8.88253689 0.2313194,8.65393727 0.463026654,8.5427144 L2.34096885,7.64127468 C2.42759746,7.32228988 2.50386559,7.07419005 2.57165467,6.89274074 C2.63878533,6.7130538 2.74293335,6.47740464 2.8854431,6.18143219 L2.06997455,4.45996626 C1.94312228,4.19217928 2.00336838,3.87420996 2.21965377,3.66998322 L3.62443163,2.34352648 C3.82439931,2.15470767 4.11840992,2.10075785 4.37358276,2.20606012 L6.27210909,2.98952564 C6.4823493,2.85093927 6.67247185,2.73658268 6.84371422,2.6461118 C7.04934485,2.53747289 7.3225817,2.42318736 7.66837893,2.29976859 L8.32789678,0.458652854 C8.42637398,0.183743082 8.68933933,0 8.98430143,0 L11.078035,0 Z M10.5870708,1.37705446 L9.47640909,1.37705446 L8.86948809,3.07134033 C8.79801391,3.27086827 8.63769115,3.42680114 8.43474473,3.49417973 C7.99915007,3.63879796 7.68401915,3.76347045 7.50006723,3.86065605 C7.30479682,3.96382144 7.05649639,4.12077045 6.75923344,4.33037214 C6.56321164,4.46858816 6.30888789,4.49688254 6.08670302,4.40519344 L4.25716409,3.65019697 L3.54351334,4.32405928 L4.2874951,5.89461557 C4.37724721,6.08408357 4.375001,6.30362324 4.2813906,6.49125715 C4.08134734,6.89222649 3.94589193,7.18842613 3.87809235,7.36990353 C3.8103478,7.55123365 3.71917424,7.8615808 3.60874921,8.29154274 C3.55823748,8.48822027 3.42255355,8.65285199 3.23793163,8.74147321 L1.44780841,9.60075854 L1.41171745,10.5802222 L3.03130231,11.0725942 C3.24698647,11.1381646 3.41716675,11.3030041 3.48790571,11.5148681 C3.64831871,11.9953067 3.7761118,12.3491471 3.86857839,12.5706968 C3.95934025,12.788162 4.09417527,13.0648832 4.27239921,13.3979523 C4.37321509,13.5863595 4.38009307,13.810311 4.29102495,14.0044194 L3.53951667,15.6421999 L4.25118794,16.3104301 L6.03251181,15.5483219 C6.22679544,15.465201 6.44877026,15.4739754 6.6357229,15.5721659 C7.00102332,15.7640277 7.27322021,15.8974495 7.44479999,15.9697176 C7.61953128,16.0433131 7.9548478,16.1653796 8.44065086,16.3314709 C8.63693275,16.3985778 8.7926767,16.548807 8.86538101,16.7411617 L9.57250939,18.6120199 L10.4993142,18.591227 L11.0961476,16.9376646 C11.1646975,16.747743 11.3140075,16.5970812 11.5046571,16.5254566 C11.8958011,16.3785088 12.2416349,16.2491584 12.5421977,16.1373911 C12.8039897,16.0400412 13.1223034,15.8867935 13.4934399,15.6776981 C13.7015148,15.5604703 13.9559143,15.5571841 14.1670155,15.6689972 L15.7439676,16.5042547 L16.6305025,15.7125069 L15.8561342,14.0011301 C15.7756691,13.8232999 15.7751619,13.6200892 15.8547382,13.4418685 C16.0370606,13.0335353 16.160351,12.7267619 16.2224704,12.5307434 C16.2832183,12.3390526 16.3456807,12.0622192 16.407072,11.7055024 C16.4492368,11.4605022 16.6216614,11.2569821 16.8582214,11.1729911 L18.5056035,10.5880863 L18.5779926,9.44770174 L16.9575114,8.75391676 C16.7827815,8.67910873 16.6466533,8.53682007 16.5808114,8.36016907 C16.4198441,7.92830106 16.2929314,7.61166725 16.2030747,7.41605965 C16.1143251,7.22286224 15.9738341,6.95669259 15.7830295,6.62172026 C15.677285,6.43607749 15.6644194,6.21248859 15.7481863,6.01618508 L16.4733058,4.31690418 L15.7093237,3.52686246 L14.2211258,4.31440213 C14.0242762,4.41857298 13.7888454,4.4230994 13.5880489,4.32657373 C13.1546705,4.11824271 12.829188,3.97550384 12.6204677,3.90084548 C12.4166956,3.82795707 12.1292655,3.75057315 11.7626377,3.671335 C11.5278825,3.62059807 11.3361711,3.45377367 11.2554479,3.22998614 L10.5870708,1.37705446 Z M10.0237083,5.64149212 C12.459442,5.64149212 14.4339942,7.59383168 14.4339942,10.0021646 C14.4339942,12.4104975 12.459442,14.362837 10.0237083,14.362837 C7.58797468,14.362837 5.61342244,12.4104975 5.61342244,10.0021646 C5.61342244,7.59383168 7.58797468,5.64149212 10.0237083,5.64149212 Z M10.0237083,7.01854658 C8.35715373,7.01854658 7.00614429,8.35435786 7.00614429,10.0021646 C7.00614429,11.6499713 8.35715373,12.9857826 10.0237083,12.9857826 C11.6902629,12.9857826 13.0412723,11.6499713 13.0412723,10.0021646 C13.0412723,8.35435786 11.6902629,7.01854658 10.0237083,7.01854658 Z" />
                                </svg>
                              </span>
                            </Tooltip>
                            <span>Config Settings</span>
                          </a>
                        </li>
                        {/* )} */}
                        {/* {history.location.pathname !== "/admin/org-settings" && ( */}
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              orgSettings();
                            }}
                          >
                            <Tooltip title="Organization" arrow>
                              <span className="dropdown-icon fill">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="16"
                                  xlink="http://www.w3.org/1999/xlink"
                                  version="1.1"
                                  id="Capa_1"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 60 60"
                                >
                                  <g>
                                    <path d="M52.179,40.5l-5.596,8.04l-3.949-3.241c-0.426-0.352-1.057-0.287-1.407,0.138c-0.351,0.427-0.289,1.058,0.139,1.407   l4.786,3.929C46.331,50.921,46.556,51,46.786,51c0.045,0,0.091-0.003,0.137-0.01c0.276-0.038,0.524-0.19,0.684-0.419l6.214-8.929   c0.315-0.453,0.204-1.076-0.25-1.392C53.117,39.933,52.495,40.046,52.179,40.5z" />
                                    <path d="M54.164,35.163C54.709,32.978,55,30.742,55,28.5C55,13.337,42.664,1,27.5,1S0,13.337,0,28.5   c0,8.01,3.444,15.229,8.927,20.259l-0.026,0.023l0.891,0.751c0.056,0.047,0.117,0.086,0.173,0.133   c0.477,0.396,0.972,0.772,1.476,1.136c0.159,0.115,0.318,0.23,0.479,0.341c0.535,0.369,1.085,0.719,1.646,1.051   c0.122,0.071,0.244,0.141,0.366,0.211c0.613,0.349,1.239,0.678,1.881,0.981c0.047,0.022,0.094,0.042,0.141,0.064   c2.089,0.971,4.319,1.684,6.65,2.105c0.062,0.011,0.123,0.022,0.185,0.033c0.723,0.125,1.455,0.225,2.197,0.292   c0.09,0.008,0.181,0.013,0.271,0.021C25.998,55.961,26.744,56,27.5,56c3.262,0,6.454-0.577,9.503-1.702   C39.389,57.168,42.984,59,47,59c7.168,0,13-5.832,13-13C60,41.478,57.677,37.492,54.164,35.163z M2,28.5C2,14.439,13.439,3,27.5,3   S53,14.439,53,28.5c0,1.903-0.214,3.804-0.639,5.666c-0.017-0.008-0.036-0.013-0.053-0.021c-0.376-0.169-0.762-0.32-1.156-0.453   c-0.034-0.011-0.067-0.026-0.101-0.037c-0.411-0.135-0.83-0.251-1.258-0.345c-0.02-0.005-0.04-0.011-0.06-0.016   c-0.417-0.09-0.841-0.158-1.271-0.207c-0.03-0.004-0.06-0.01-0.09-0.014C47.921,33.027,47.464,33,47,33   c-5.923,0-10.923,3.986-12.485,9.413C34.077,42,33.818,41.425,33.818,40.8v-2.957c0.198-0.243,0.405-0.518,0.617-0.817   c1.096-1.547,1.975-3.269,2.616-5.123c1.266-0.602,2.085-1.864,2.085-3.289v-3.545c0-0.866-0.318-1.708-0.886-2.369v-4.667   c0.052-0.52,0.236-3.448-1.883-5.864C34.524,10.065,31.541,9,27.5,9s-7.024,1.065-8.867,3.168   c-2.119,2.416-1.935,5.346-1.883,5.864v4.667c-0.568,0.661-0.886,1.503-0.886,2.369v3.545c0,1.101,0.494,2.128,1.339,2.821   c0.81,3.173,2.476,5.575,3.092,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313c-0.253,0.138-0.502,0.298-0.752,0.477   C5.276,42.792,2,36.022,2,28.5z M25.605,53.922c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.266-0.131-1.893-0.234   c-0.026-0.004-0.052-0.01-0.077-0.014c-1.327-0.222-2.632-0.548-3.903-0.974c-0.034-0.011-0.068-0.023-0.102-0.035   c-1.237-0.42-2.44-0.939-3.601-1.544c-0.067-0.035-0.135-0.068-0.201-0.103c-0.515-0.275-1.019-0.573-1.515-0.883   c-0.143-0.09-0.284-0.181-0.425-0.273c-0.456-0.298-0.905-0.608-1.343-0.936c-0.045-0.034-0.088-0.07-0.133-0.104   c0.032-0.018,0.064-0.036,0.097-0.054l7.907-4.313c1.359-0.742,2.204-2.165,2.204-3.714v-3.603l-0.233-0.278   c-0.021-0.025-2.176-2.634-2.999-6.215l-0.091-0.396l-0.341-0.221c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545   c0-0.465,0.198-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131c-0.003-0.024-0.298-2.429,1.396-4.36   C21.583,11.837,24.06,11,27.5,11c3.425,0,5.897,0.83,7.346,2.466c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298   c0.359,0.324,0.557,0.758,0.557,1.223v3.545c0,0.724-0.475,1.356-1.181,1.574l-0.498,0.154l-0.16,0.496   c-0.589,1.833-1.429,3.525-2.496,5.032c-0.259,0.367-0.514,0.695-0.736,0.948l-0.248,0.283V40.8c0,1.587,0.868,3.015,2.268,3.746   C34.033,45.024,34,45.508,34,46c0,0.292,0.01,0.583,0.029,0.873c0.007,0.103,0.021,0.205,0.031,0.307   c0.009,0.096,0.018,0.191,0.029,0.287c0.01,0.09,0.015,0.181,0.027,0.27c0.023,0.17,0.056,0.338,0.086,0.507   c0.02,0.115,0.035,0.231,0.058,0.345c0,0,0.002,0.008,0.003,0.012c0.006,0.03,0.015,0.058,0.021,0.088   c0.031,0.146,0.068,0.291,0.104,0.436c0.025,0.101,0.045,0.202,0.072,0.302c0.024,0.088,0.055,0.173,0.081,0.26   c0.034,0.116,0.07,0.231,0.108,0.345c0.024,0.072,0.042,0.145,0.067,0.216c0.07,0.201,0.15,0.399,0.23,0.596   c0.001,0.003,0.002,0.005,0.003,0.008c0.061,0.15,0.125,0.297,0.191,0.444c0.049,0.109,0.1,0.218,0.152,0.326   c0.034,0.071,0.064,0.143,0.099,0.213c0.023,0.046,0.05,0.09,0.074,0.136c0.084,0.163,0.173,0.322,0.264,0.48   c0.027,0.047,0.051,0.096,0.078,0.143C33.119,53.527,30.33,54,27.5,54C26.866,54,26.234,53.969,25.605,53.922z M47,57   c-3.661,0-6.901-1.805-8.902-4.564c-0.083-0.114-0.158-0.231-0.236-0.347c-0.054-0.08-0.111-0.158-0.162-0.239   c-0.043-0.069-0.085-0.138-0.127-0.208c-0.045-0.074-0.085-0.15-0.128-0.225c-0.069-0.122-0.143-0.241-0.207-0.365   c-0.047-0.091-0.089-0.185-0.134-0.278c-0.012-0.025-0.023-0.051-0.035-0.076c-0.075-0.157-0.153-0.312-0.221-0.472   c-0.036-0.085-0.063-0.173-0.097-0.258c-0.077-0.199-0.155-0.398-0.221-0.602c-0.031-0.095-0.055-0.193-0.083-0.289   c-0.009-0.03-0.017-0.059-0.025-0.088c-0.056-0.199-0.11-0.399-0.155-0.603c-0.014-0.063-0.025-0.127-0.038-0.191   c-0.012-0.06-0.025-0.121-0.036-0.181c-0.041-0.222-0.075-0.446-0.103-0.672c-0.003-0.026-0.006-0.052-0.009-0.079   c-0.009-0.082-0.022-0.164-0.029-0.246C36.021,46.681,36,46.343,36,46c0-0.315,0.021-0.626,0.047-0.934   c0.028-0.295,0.067-0.599,0.122-0.919l0.074-0.433C37.298,38.742,41.719,35,47,35c0.446,0,0.89,0.034,1.332,0.089   c0.101,0.012,0.199,0.031,0.299,0.046c0.365,0.055,0.728,0.127,1.086,0.219c0.075,0.019,0.15,0.037,0.225,0.058   c0.882,0.247,1.735,0.601,2.537,1.063C55.773,38.377,58,41.93,58,46C58,52.065,53.065,57,47,57z" />
                                  </g>
                                </svg>
                              </span>
                            </Tooltip>
                            <span>Organization</span>
                          </a>
                        </li>
                        {/* )} */}
                        <li>
                          <Link className="dropdown-item" to="/admin/project-list">
                            <span className="dropdown-icon fill">
                              <svg
                                width="21"
                                height="19"
                                viewBox="0 0 21 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {' '}
                                <title>Dashboard</title>
                                <path
                                  d="M12.0162 18.3333H8.98286C8.59129 18.3333 8.25249 18.0608 8.16869 17.6783L7.82953 16.1083C7.37707 15.9101 6.94805 15.6621 6.55036 15.3691L5.01953 15.8566C4.64619 15.9757 4.24035 15.8185 4.04453 15.4791L2.52453 12.8533C2.33085 12.5137 2.39757 12.0854 2.68536 11.8208L3.87286 10.7375C3.81886 10.2467 3.81886 9.75153 3.87286 9.26079L2.68536 8.17996C2.39715 7.91527 2.3304 7.48639 2.52453 7.14663L4.04119 4.51913C4.23701 4.17971 4.64286 4.02257 5.01619 4.14163L6.54703 4.62913C6.75041 4.47842 6.96214 4.33931 7.18119 4.21246C7.39148 4.09387 7.60789 3.9865 7.82953 3.89079L8.16953 2.32246C8.25292 1.93993 8.59135 1.66704 8.98286 1.66663H12.0162C12.4077 1.66704 12.7461 1.93993 12.8295 2.32246L13.1729 3.89163C13.4068 3.99456 13.6347 4.11086 13.8554 4.23996C14.0611 4.35897 14.2601 4.48945 14.4512 4.63079L15.9829 4.14329C16.3559 4.02468 16.7613 4.18176 16.957 4.52079L18.4737 7.14829C18.6674 7.48786 18.6006 7.91622 18.3129 8.18079L17.1254 9.26413C17.1794 9.75487 17.1794 10.2501 17.1254 10.7408L18.3129 11.8241C18.6006 12.0887 18.6674 12.5171 18.4737 12.8566L16.957 15.4841C16.7613 15.8232 16.3559 15.9802 15.9829 15.8616L14.4512 15.3741C14.2574 15.5169 14.056 15.649 13.8479 15.77C13.6294 15.8965 13.404 16.0109 13.1729 16.1125L12.8295 17.6783C12.7458 18.0605 12.4075 18.333 12.0162 18.3333ZM6.84953 13.5241L7.53286 14.0241C7.6869 14.1376 7.84745 14.2419 8.01369 14.3366C8.17011 14.4272 8.33116 14.5095 8.49619 14.5833L9.27369 14.9241L9.65453 16.6666H11.3462L11.727 14.9233L12.5045 14.5825C12.8439 14.4328 13.1661 14.2467 13.4654 14.0275L14.1495 13.5275L15.8504 14.0691L16.6962 12.6041L15.377 11.4016L15.4704 10.5583C15.5114 10.1894 15.5114 9.81716 15.4704 9.44829L15.377 8.60496L16.697 7.39996L15.8504 5.93413L14.1495 6.47579L13.4654 5.97579C13.166 5.75555 12.8439 5.56809 12.5045 5.41663L11.727 5.07579L11.3462 3.33329H9.65453L9.27203 5.07663L8.49619 5.41663C8.33103 5.48916 8.16996 5.57067 8.01369 5.66079C7.84847 5.75523 7.68877 5.85901 7.53536 5.97163L6.85119 6.47163L5.15119 5.92996L4.30369 7.39996L5.62286 8.60079L5.52953 9.44496C5.48853 9.81382 5.48853 10.1861 5.52953 10.555L5.62286 11.3983L4.30369 12.6008L5.14953 14.0658L6.84953 13.5241ZM10.4962 13.3333C8.65524 13.3333 7.16286 11.8409 7.16286 9.99996C7.16286 8.15901 8.65524 6.66663 10.4962 6.66663C12.3371 6.66663 13.8295 8.15901 13.8295 9.99996C13.8272 11.84 12.3362 13.331 10.4962 13.3333ZM10.4962 8.33329C9.58569 8.33422 8.84443 9.06567 8.83139 9.97608C8.81834 10.8865 9.53833 11.6389 10.4484 11.6659C11.3585 11.6929 12.1219 10.9845 12.1629 10.075V10.4083V9.99996C12.1629 9.07948 11.4167 8.33329 10.4962 8.33329Z"
                                  fill=""
                                />
                              </svg>
                            </span>
                            <span>Super Admin Dashboard</span>
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/admin/render-list">
                            <Tooltip title="render-list" arrow>
                              <span className="dropdown-icon fill">
                                <svg
                                  width="21"
                                  height="16"
                                  xmlns="http://www.w3.org/2000/svg"
                                  id="Layer_1"
                                  data-name="Layer 1"
                                  viewBox="0 0 99.09 122.88"
                                >
                                  <title>Render List</title>
                                  <path d="M64.64,13,86.77,36.21H64.64V13ZM42.58,71.67a3.25,3.25,0,0,1-4.92-4.25l9.42-10.91a3.26,3.26,0,0,1,4.59-.33,5.14,5.14,0,0,1,.4.41l9.3,10.28a3.24,3.24,0,0,1-4.81,4.35L52.8,67.07V82.52a3.26,3.26,0,1,1-6.52,0V67.38l-3.7,4.29ZM24.22,85.42a3.26,3.26,0,1,1,6.52,0v7.46H68.36V85.42a3.26,3.26,0,1,1,6.51,0V96.14a3.26,3.26,0,0,1-3.26,3.26H27.48a3.26,3.26,0,0,1-3.26-3.26V85.42ZM99.08,39.19c.15-.57-1.18-2.07-2.68-3.56L63.8,1.36A3.63,3.63,0,0,0,61,0H6.62A6.62,6.62,0,0,0,0,6.62V116.26a6.62,6.62,0,0,0,6.62,6.62H92.46a6.62,6.62,0,0,0,6.62-6.62V39.19Zm-7.4,4.42v71.87H7.4V7.37H57.25V39.9A3.71,3.71,0,0,0,61,43.61Z" />
                                </svg>
                              </span>
                            </Tooltip>
                            <span>Render List</span>
                          </Link>
                        </li>

                        <li>
                          <Link className="dropdown-item" to="/admin/cluster-settings">
                            <Tooltip title="render-list" arrow>
                              <span className="dropdown-icon fill">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="16"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M11.078035,0 C11.3724371,0 11.6350302,0.183056678 11.7339285,0.457230801 L12.4396543,2.41370379 C12.6930786,2.47650967 12.9108093,2.54030436 13.0942558,2.60592238 C13.2952001,2.67779926 13.5540423,2.78741449 13.8746747,2.93586046 L15.5184936,2.06596774 C15.794148,1.92009416 16.1343396,1.97375545 16.3504064,2.19719235 L17.7960017,3.69209722 C17.98787,3.8905102 18.0422042,4.18265582 17.9342767,4.43557836 L17.162857,6.24336136 C17.2913496,6.47797752 17.3939318,6.67854463 17.4711247,6.84658462 C17.5553742,7.02998593 17.6588292,7.28241713 17.7829588,7.60671302 L19.580333,8.37623211 C19.8497082,8.4915611 20.0170118,8.76152727 19.9986241,9.05119919 L19.8669066,11.126215 C19.8494975,11.4004703 19.668825,11.6382294 19.4072566,11.7310995 L17.7049419,12.3355083 C17.6562729,12.5705675 17.6053791,12.772402 17.551477,12.9424906 C17.4883274,13.1417599 17.389065,13.3979932 17.2526724,13.7155635 L18.1084613,15.6068822 C18.2316885,15.879218 18.1635045,16.1990386 17.9395819,16.3990196 L16.3138559,17.8509252 C16.0957241,18.0457347 15.7773686,18.084139 15.5182641,17.9469002 L13.8421792,17.0591354 C13.5477413,17.2124998 13.2783109,17.3348831 13.0324612,17.4263047 C12.8127426,17.5080092 12.5685018,17.5992352 12.2997543,17.6999771 L11.6499659,19.5002547 C11.5529743,19.7689756 11.2984077,19.9507082 11.0099151,19.9571805 L9.10927684,20 C8.81300029,20.0064684 8.54492708,19.8269822 8.44118272,19.5525044 L7.6751041,17.5256808 C7.3232066,17.4026533 7.06612795,17.3070148 6.89898146,17.2366139 C6.74058527,17.1698987 6.53544077,17.0722593 6.28058727,16.9426265 L4.38190658,17.7549437 C4.12577479,17.8645252 3.82821583,17.812324 3.62584584,17.6223069 L2.22106797,16.3032781 C2.00593124,16.1012735 1.94386481,15.7866753 2.0664447,15.519534 L2.88322205,13.7395109 C2.76017205,13.4979963 2.65957084,13.2838441 2.58116863,13.0959926 C2.49857708,12.8981035 2.39862152,12.628586 2.28009144,12.2848943 L0.491710371,11.7412063 C0.190471763,11.6496264 -0.0110085834,11.3694211 0.000465944291,11.0580168 L0.071249487,9.13703967 C0.0806273232,8.88253689 0.2313194,8.65393727 0.463026654,8.5427144 L2.34096885,7.64127468 C2.42759746,7.32228988 2.50386559,7.07419005 2.57165467,6.89274074 C2.63878533,6.7130538 2.74293335,6.47740464 2.8854431,6.18143219 L2.06997455,4.45996626 C1.94312228,4.19217928 2.00336838,3.87420996 2.21965377,3.66998322 L3.62443163,2.34352648 C3.82439931,2.15470767 4.11840992,2.10075785 4.37358276,2.20606012 L6.27210909,2.98952564 C6.4823493,2.85093927 6.67247185,2.73658268 6.84371422,2.6461118 C7.04934485,2.53747289 7.3225817,2.42318736 7.66837893,2.29976859 L8.32789678,0.458652854 C8.42637398,0.183743082 8.68933933,0 8.98430143,0 L11.078035,0 Z M10.5870708,1.37705446 L9.47640909,1.37705446 L8.86948809,3.07134033 C8.79801391,3.27086827 8.63769115,3.42680114 8.43474473,3.49417973 C7.99915007,3.63879796 7.68401915,3.76347045 7.50006723,3.86065605 C7.30479682,3.96382144 7.05649639,4.12077045 6.75923344,4.33037214 C6.56321164,4.46858816 6.30888789,4.49688254 6.08670302,4.40519344 L4.25716409,3.65019697 L3.54351334,4.32405928 L4.2874951,5.89461557 C4.37724721,6.08408357 4.375001,6.30362324 4.2813906,6.49125715 C4.08134734,6.89222649 3.94589193,7.18842613 3.87809235,7.36990353 C3.8103478,7.55123365 3.71917424,7.8615808 3.60874921,8.29154274 C3.55823748,8.48822027 3.42255355,8.65285199 3.23793163,8.74147321 L1.44780841,9.60075854 L1.41171745,10.5802222 L3.03130231,11.0725942 C3.24698647,11.1381646 3.41716675,11.3030041 3.48790571,11.5148681 C3.64831871,11.9953067 3.7761118,12.3491471 3.86857839,12.5706968 C3.95934025,12.788162 4.09417527,13.0648832 4.27239921,13.3979523 C4.37321509,13.5863595 4.38009307,13.810311 4.29102495,14.0044194 L3.53951667,15.6421999 L4.25118794,16.3104301 L6.03251181,15.5483219 C6.22679544,15.465201 6.44877026,15.4739754 6.6357229,15.5721659 C7.00102332,15.7640277 7.27322021,15.8974495 7.44479999,15.9697176 C7.61953128,16.0433131 7.9548478,16.1653796 8.44065086,16.3314709 C8.63693275,16.3985778 8.7926767,16.548807 8.86538101,16.7411617 L9.57250939,18.6120199 L10.4993142,18.591227 L11.0961476,16.9376646 C11.1646975,16.747743 11.3140075,16.5970812 11.5046571,16.5254566 C11.8958011,16.3785088 12.2416349,16.2491584 12.5421977,16.1373911 C12.8039897,16.0400412 13.1223034,15.8867935 13.4934399,15.6776981 C13.7015148,15.5604703 13.9559143,15.5571841 14.1670155,15.6689972 L15.7439676,16.5042547 L16.6305025,15.7125069 L15.8561342,14.0011301 C15.7756691,13.8232999 15.7751619,13.6200892 15.8547382,13.4418685 C16.0370606,13.0335353 16.160351,12.7267619 16.2224704,12.5307434 C16.2832183,12.3390526 16.3456807,12.0622192 16.407072,11.7055024 C16.4492368,11.4605022 16.6216614,11.2569821 16.8582214,11.1729911 L18.5056035,10.5880863 L18.5779926,9.44770174 L16.9575114,8.75391676 C16.7827815,8.67910873 16.6466533,8.53682007 16.5808114,8.36016907 C16.4198441,7.92830106 16.2929314,7.61166725 16.2030747,7.41605965 C16.1143251,7.22286224 15.9738341,6.95669259 15.7830295,6.62172026 C15.677285,6.43607749 15.6644194,6.21248859 15.7481863,6.01618508 L16.4733058,4.31690418 L15.7093237,3.52686246 L14.2211258,4.31440213 C14.0242762,4.41857298 13.7888454,4.4230994 13.5880489,4.32657373 C13.1546705,4.11824271 12.829188,3.97550384 12.6204677,3.90084548 C12.4166956,3.82795707 12.1292655,3.75057315 11.7626377,3.671335 C11.5278825,3.62059807 11.3361711,3.45377367 11.2554479,3.22998614 L10.5870708,1.37705446 Z M10.0237083,5.64149212 C12.459442,5.64149212 14.4339942,7.59383168 14.4339942,10.0021646 C14.4339942,12.4104975 12.459442,14.362837 10.0237083,14.362837 C7.58797468,14.362837 5.61342244,12.4104975 5.61342244,10.0021646 C5.61342244,7.59383168 7.58797468,5.64149212 10.0237083,5.64149212 Z M10.0237083,7.01854658 C8.35715373,7.01854658 7.00614429,8.35435786 7.00614429,10.0021646 C7.00614429,11.6499713 8.35715373,12.9857826 10.0237083,12.9857826 C11.6902629,12.9857826 13.0412723,11.6499713 13.0412723,10.0021646 C13.0412723,8.35435786 11.6902629,7.01854658 10.0237083,7.01854658 Z" />
                                </svg>
                              </span>
                            </Tooltip>
                            <span>Cluster Settings</span>
                          </Link>
                        </li>

                        {/* )} */}
                      </ul>
                    )}
                  </div>
                </div>
              </li>
            )}
            <li className="me-3">
              <a className="notification not-allowed">
                <Tooltip title="Notification" arrow>
                  <svg
                    width="26"
                    height="27"
                    viewBox="0 0 26 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 23.5H15"
                      stroke=""
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.26904 12.2499C5.2678 11.3605 5.44262 10.4795 5.78343 9.6579C6.12424 8.83628 6.6243 8.09025 7.25477 7.4628C7.88525 6.83535 8.63368 6.33889 9.45693 6.00204C10.2802 5.66519 11.1619 5.49461 12.0514 5.50013C15.763 5.52772 18.7317 8.61275 18.7317 12.3347V12.9999C18.7317 16.3577 19.4342 18.3061 20.0529 19.371C20.1196 19.4848 20.1551 19.6142 20.1558 19.746C20.1565 19.8779 20.1224 20.0076 20.0569 20.1221C19.9915 20.2366 19.8971 20.3318 19.7831 20.3982C19.6691 20.4645 19.5397 20.4996 19.4078 20.4999H4.59222C4.46034 20.4996 4.33087 20.4645 4.21689 20.3981C4.1029 20.3318 4.00844 20.2366 3.94301 20.122C3.87759 20.0075 3.84352 19.8778 3.84425 19.7459C3.84498 19.614 3.88048 19.4846 3.94716 19.3709C4.56622 18.3059 5.26904 16.3575 5.26904 12.9999L5.26904 12.2499Z"
                      stroke=""
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <g filter="url(#filter0_d_2153:4589)"></g>
                    <defs>
                      <filter
                        id="filter0_d_2153:4589"
                        x="8"
                        y="0.5"
                        width="18"
                        height="18"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.27451 0 0 0 0 0.545098 0 0 0 0 0.909804 0 0 0 0.39 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_2153:4589"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_2153:4589"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </Tooltip>
                <span className="noti-icon-badge rounded-circle"></span>
              </a>
            </li>
            <li>
              <div className="dropdown">
                <a
                  className=" dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="account-user-avatar">
                    <Tooltip title="Account" arrow>
                      {/* <img src='../../../assets/img/asset-tick.svg' /> */}
                      <img src="../../../assets/img/avatar.png" alt="user-image" className="" />
                    </Tooltip>
                  </span>
                </a>

                <div className="dropdown-menu " aria-labelledby="dropdownMenuButton1">
                  <div className=" dropdown-header noti-title">
                    <h6 className="text-overflow m-0">
                      orgName:
                      {userDetails !== undefined &&
                      userDetails.orgName !== undefined &&
                      userDetails.orgName !== ''
                        ? userDetails.orgName
                        : userDetails !== undefined &&
                          userDetails.email !== undefined &&
                          userDetails.email !== '' &&
                          userDetails.email}
                    </h6>
                    <h6 className="text-overflow m-0">{userName}</h6>
                    <p>{Email}</p>
                  </div>
                  <ul>
                    {createProjecteEnable && (
                      <li onClick={createProject}>
                        <a className="dropdown-item">
                          <span className="dropdown-icon stroke">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.125 10H16.875"
                                stroke=""
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10 3.125V16.875"
                                stroke=""
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span>New Project</span>
                        </a>
                      </li>
                    )}

                    <li>
                      <a className="dropdown-item disabled">
                        <span className="dropdown-icon fill">
                          <svg
                            width="21"
                            height="19"
                            viewBox="0 0 21 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.0162 18.3333H8.98286C8.59129 18.3333 8.25249 18.0608 8.16869 17.6783L7.82953 16.1083C7.37707 15.9101 6.94805 15.6621 6.55036 15.3691L5.01953 15.8566C4.64619 15.9757 4.24035 15.8185 4.04453 15.4791L2.52453 12.8533C2.33085 12.5137 2.39757 12.0854 2.68536 11.8208L3.87286 10.7375C3.81886 10.2467 3.81886 9.75153 3.87286 9.26079L2.68536 8.17996C2.39715 7.91527 2.3304 7.48639 2.52453 7.14663L4.04119 4.51913C4.23701 4.17971 4.64286 4.02257 5.01619 4.14163L6.54703 4.62913C6.75041 4.47842 6.96214 4.33931 7.18119 4.21246C7.39148 4.09387 7.60789 3.9865 7.82953 3.89079L8.16953 2.32246C8.25292 1.93993 8.59135 1.66704 8.98286 1.66663H12.0162C12.4077 1.66704 12.7461 1.93993 12.8295 2.32246L13.1729 3.89163C13.4068 3.99456 13.6347 4.11086 13.8554 4.23996C14.0611 4.35897 14.2601 4.48945 14.4512 4.63079L15.9829 4.14329C16.3559 4.02468 16.7613 4.18176 16.957 4.52079L18.4737 7.14829C18.6674 7.48786 18.6006 7.91622 18.3129 8.18079L17.1254 9.26413C17.1794 9.75487 17.1794 10.2501 17.1254 10.7408L18.3129 11.8241C18.6006 12.0887 18.6674 12.5171 18.4737 12.8566L16.957 15.4841C16.7613 15.8232 16.3559 15.9802 15.9829 15.8616L14.4512 15.3741C14.2574 15.5169 14.056 15.649 13.8479 15.77C13.6294 15.8965 13.404 16.0109 13.1729 16.1125L12.8295 17.6783C12.7458 18.0605 12.4075 18.333 12.0162 18.3333ZM6.84953 13.5241L7.53286 14.0241C7.6869 14.1376 7.84745 14.2419 8.01369 14.3366C8.17011 14.4272 8.33116 14.5095 8.49619 14.5833L9.27369 14.9241L9.65453 16.6666H11.3462L11.727 14.9233L12.5045 14.5825C12.8439 14.4328 13.1661 14.2467 13.4654 14.0275L14.1495 13.5275L15.8504 14.0691L16.6962 12.6041L15.377 11.4016L15.4704 10.5583C15.5114 10.1894 15.5114 9.81716 15.4704 9.44829L15.377 8.60496L16.697 7.39996L15.8504 5.93413L14.1495 6.47579L13.4654 5.97579C13.166 5.75555 12.8439 5.56809 12.5045 5.41663L11.727 5.07579L11.3462 3.33329H9.65453L9.27203 5.07663L8.49619 5.41663C8.33103 5.48916 8.16996 5.57067 8.01369 5.66079C7.84847 5.75523 7.68877 5.85901 7.53536 5.97163L6.85119 6.47163L5.15119 5.92996L4.30369 7.39996L5.62286 8.60079L5.52953 9.44496C5.48853 9.81382 5.48853 10.1861 5.52953 10.555L5.62286 11.3983L4.30369 12.6008L5.14953 14.0658L6.84953 13.5241ZM10.4962 13.3333C8.65524 13.3333 7.16286 11.8409 7.16286 9.99996C7.16286 8.15901 8.65524 6.66663 10.4962 6.66663C12.3371 6.66663 13.8295 8.15901 13.8295 9.99996C13.8272 11.84 12.3362 13.331 10.4962 13.3333ZM10.4962 8.33329C9.58569 8.33422 8.84443 9.06567 8.83139 9.97608C8.81834 10.8865 9.53833 11.6389 10.4484 11.6659C11.3585 11.6929 12.1219 10.9845 12.1629 10.075V10.4083V9.99996C12.1629 9.07948 11.4167 8.33329 10.4962 8.33329Z"
                              fill=""
                            />
                          </svg>
                        </span>
                        <span>Settings and Privacy</span>
                      </a>
                    </li>
                    {/* {history.location.pathname !== "/templateupload" &&AdminRole==0&& (
                    <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            openTemplate();
                          }}
                        >
                          <span className="dropdown-icon fill">
                            <svg
                              width="21"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.75 5.71429C3.26047 5.71429 2.86364 6.09804 2.86364 6.57143V11.7143C2.86364 12.1877 3.26047 12.5714 3.75 12.5714C4.23953 12.5714 4.63636 12.1877 4.63636 11.7143V6.57143C4.63636 6.09804 4.23953 5.71429 3.75 5.71429ZM6.11364 7.71429C6.11364 7.2409 6.51047 6.85714 7 6.85714C7.48952 6.85714 7.88636 7.2409 7.88636 7.71429V11.7143C7.88636 12.1877 7.48952 12.5714 7 12.5714C6.51047 12.5714 6.11364 12.1877 6.11364 11.7143V7.71429ZM10.25 9.14286C9.76048 9.14286 9.36364 9.52661 9.36364 10V11.7143C9.36364 12.1877 9.76048 12.5714 10.25 12.5714C10.7395 12.5714 11.1364 12.1877 11.1364 11.7143V10C11.1364 9.52661 10.7395 9.14286 10.25 9.14286ZM8.77273 0C9.54458 0 10.2012 0.477033 10.4446 1.14286H11.4318C12.574 1.14286 13.5 2.03829 13.5 3.14286V14C13.5 15.1046 12.574 16 11.4318 16H2.56818C1.42596 16 0.5 15.1046 0.5 14V3.14286C0.5 2.03829 1.42596 1.14286 2.56818 1.14286H3.55542C3.79877 0.477033 4.45542 0 5.22727 0H8.77273ZM5.22727 1.14286C4.90092 1.14286 4.63636 1.39869 4.63636 1.71429C4.63636 2.02988 4.90092 2.28571 5.22727 2.28571H8.77273C9.09908 2.28571 9.36364 2.02988 9.36364 1.71429C9.36364 1.39869 9.09908 1.14286 8.77273 1.14286H5.22727ZM2.56818 2.28571C2.07866 2.28571 1.68182 2.66947 1.68182 3.14286V14C1.68182 14.4734 2.07866 14.8571 2.56818 14.8571H11.4318C11.9213 14.8571 12.3182 14.4734 12.3182 14V3.14286C12.3182 2.66947 11.9213 2.28571 11.4318 2.28571H10.4446C10.2012 2.95154 9.54458 3.42857 8.77273 3.42857H5.22727C4.45542 3.42857 3.79877 2.95154 3.55542 2.28571H2.56818Z" />
                            </svg>
                          </span>
                          <span>Template Uplaod</span>
                        </a>
                      </li>  )} */}
                    {/* {history.location.pathname !== "/project-list" && (
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setOpenDashboard(true);
                          }}
                        >
                          <span className="dropdown-icon fill">
                            <svg
                              width="21"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.75 5.71429C3.26047 5.71429 2.86364 6.09804 2.86364 6.57143V11.7143C2.86364 12.1877 3.26047 12.5714 3.75 12.5714C4.23953 12.5714 4.63636 12.1877 4.63636 11.7143V6.57143C4.63636 6.09804 4.23953 5.71429 3.75 5.71429ZM6.11364 7.71429C6.11364 7.2409 6.51047 6.85714 7 6.85714C7.48952 6.85714 7.88636 7.2409 7.88636 7.71429V11.7143C7.88636 12.1877 7.48952 12.5714 7 12.5714C6.51047 12.5714 6.11364 12.1877 6.11364 11.7143V7.71429ZM10.25 9.14286C9.76048 9.14286 9.36364 9.52661 9.36364 10V11.7143C9.36364 12.1877 9.76048 12.5714 10.25 12.5714C10.7395 12.5714 11.1364 12.1877 11.1364 11.7143V10C11.1364 9.52661 10.7395 9.14286 10.25 9.14286ZM8.77273 0C9.54458 0 10.2012 0.477033 10.4446 1.14286H11.4318C12.574 1.14286 13.5 2.03829 13.5 3.14286V14C13.5 15.1046 12.574 16 11.4318 16H2.56818C1.42596 16 0.5 15.1046 0.5 14V3.14286C0.5 2.03829 1.42596 1.14286 2.56818 1.14286H3.55542C3.79877 0.477033 4.45542 0 5.22727 0H8.77273ZM5.22727 1.14286C4.90092 1.14286 4.63636 1.39869 4.63636 1.71429C4.63636 2.02988 4.90092 2.28571 5.22727 2.28571H8.77273C9.09908 2.28571 9.36364 2.02988 9.36364 1.71429C9.36364 1.39869 9.09908 1.14286 8.77273 1.14286H5.22727ZM2.56818 2.28571C2.07866 2.28571 1.68182 2.66947 1.68182 3.14286V14C1.68182 14.4734 2.07866 14.8571 2.56818 14.8571H11.4318C11.9213 14.8571 12.3182 14.4734 12.3182 14V3.14286C12.3182 2.66947 11.9213 2.28571 11.4318 2.28571H10.4446C10.2012 2.95154 9.54458 3.42857 8.77273 3.42857H5.22727C4.45542 3.42857 3.79877 2.95154 3.55542 2.28571H2.56818Z" />
                            </svg>
                          </span>
                          <span>Dashboard</span>
                        </a>
                      </li>
                    )} */}
                    <li>
                      <Link className="dropdown-item" to="/edit-profile">
                        <span className="dropdown-icon fill">
                          <svg
                            fill=""
                            height="21"
                            width="19 "
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            enable-background="new 0 0 24 24"
                          >
                            <g id="user-admin">
                              <path
                                d="M22.3,16.7l1.4-1.4L20,11.6l-5.8,5.8c-0.5-0.3-1.1-0.4-1.7-0.4C10.6,17,9,18.6,9,20.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5
        c0-0.6-0.2-1.2-0.4-1.7l1.9-1.9l2.3,2.3l1.4-1.4l-2.3-2.3l1.1-1.1L22.3,16.7z M12.5,22c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5
        s1.5,0.7,1.5,1.5S13.3,22,12.5,22z"
                              />
                              <path
                                d="M2,19c0-3.9,3.1-7,7-7c2,0,3.9,0.9,5.3,2.4l1.5-1.3c-0.9-1-1.9-1.8-3.1-2.3C14.1,9.7,15,7.9,15,6c0-3.3-2.7-6-6-6
        S3,2.7,3,6c0,1.9,0.9,3.7,2.4,4.8C2.2,12.2,0,15.3,0,19v5h8v-2H2V19z M5,6c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S5,8.2,5,6z"
                              />
                            </g>
                          </svg>
                        </span>
                        <span>Profile</span>
                      </Link>
                    </li>
                    <li onClick={logout}>
                      <a className="dropdown-item">
                        <span className="dropdown-icon fill">
                          <svg
                            width="21"
                            height="19"
                            viewBox="0 0 21 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.1595 17.5H8.6595C7.73903 17.5 6.99284 16.7538 6.99284 15.8333V12.5H8.6595V15.8333H16.1595V4.16667H8.6595V7.5H6.99284V4.16667C6.99284 3.24619 7.73903 2.5 8.6595 2.5H16.1595C17.08 2.5 17.8262 3.24619 17.8262 4.16667V15.8333C17.8262 16.7538 17.08 17.5 16.1595 17.5ZM10.3262 13.3333V10.8333H2.82617V9.16667H10.3262V6.66667L14.4928 10L10.3262 13.3333Z"
                              fill=""
                            />
                          </svg>
                        </span>
                        <span>Logout</span>
                      </a>
                    </li>
                  </ul>
                  <div className="mode-change d-flex">
                    <h6>{DisplayMode ? 'Dark Mode' : 'Light Mode'}</h6>
                    {/* <div className="toggle-switch"> */}
                    <label>
                      {/* <Checkbox
                           onChange={onChange} defaultChecked={!isChecked}
                          color="primary"
                          inputProps={{ 'aria-label': 'secondary checkbox' }}
                        /> */}
                      <Switch onChange={onChange} color="default" defaultChecked={DisplayMode} />
                      {/* <input type="checkbox" onChange={onChange} defaultChecked={!isChecked} /> */}
                      {/* <span className="slider"></span> */}
                    </label>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </li>
          </ul>
          <div
            className={
              !Toggleright
                ? 'toggle-wrap right-sec-toggle '
                : 'toggle-wrap right-sec-toggle  active'
            }
            onClick={smallRightScreenToggle}
          >
            <span className="toggle-bar"></span>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={OpenDashboard}
        Closemodal={setOpenDashboard}
        Header="Are you sure ?"
        Content="you want to exit from the project?"
        Buttonlabel="Yes, Exit it!"
        Buttonclick={backToDashboard}
      />
      <UserCreateModal
        closePreview={() => setAddUserPopup(false)}
        createUserModal={addUserPopup}
        setnewUsers={setnewUser}
        orgId={userParentId}
        // selectedImage={selectedImageFile}
      />
      {/* <UserRolepage
        closePreview={() => setAddUserPopup(false)}
        createUserModal={addUserPopup}
        setnewUsers={setnewUser}
        orgId={userParentId}

      /> */}
    </>
  );
}

// import React, { useState, useEffect } from 'react';
// import { useHistory, useParams } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { getProjectID } from '../../../services/api.service';
// import { bindActionCreators } from 'redux';
// import { actionCreator } from '../../../store/index';

// export default function Header(props) {
//   const history = useHistory();
//   const [ProjectName, setProjectName] = useState();
//   const [isEditProjectName, setisEditProjectName] = useState(false);
//   const [editProjectNameValue, seteditProjectNameValue] = useState(undefined);
//   const params = useParams();
//   let projectID = useSelector(state => state.project.ProjectId);
//   let project = useSelector(state => state.project);
//   let preview = useSelector(state => state.preview);

//   const dispatch = useDispatch();
//   const { ChangeProjectName, ChangeProjectNameInPreview } = bindActionCreators(
//     actionCreator,
//     dispatch
//   );

//   // yuo can find all params from here

//   useEffect(() => {
//     let filter = {
//       project_id: params.id,
//     };
//     getProjectID(filter).then(response => {
//       try {
//         if (
//           response !== '' &&
//           response !== undefined &&
//           response !== null &&
//           response.status !== '' &&
//           response.status !== undefined &&
//           response.status !== null &&
//           response.status === 200 &&
//           response.data !== '' &&
//           response.data !== undefined &&
//           response.data !== null
//         ) {
//           // let projectData = JSON.parse(response.data[0].ProjectData);
//           setProjectName(response.data[0].ProjectName);
//         }
//       } catch (error) {}
//     });
//   }, []);

//   useEffect(() => {
//     if (
//       history.location.pathname.includes('project-preview') ||
//       history.location.pathname.includes('edit-project')
//     ) {
//       if (history.location.pathname.includes('project-preview')) {
//         if (preview.previewProject[params.id] != null) {
//           setProjectName(preview.previewProject[params.id].ProjectName);
//         }
//       } else {
//         if (project.createdProject[projectID] != null) {
//           setProjectName(project.createdProject[projectID].ProjectName);
//         } else {
//           //15 sec => redirect to project creation page
//         }
//       }
//     } else {
//       setProjectName('');
//     }
//   }, [project, preview]);

//   const editProjectName = () => {
//     if (
//       editProjectNameValue == null ||
//       editProjectNameValue == undefined ||
//       editProjectNameValue == ''
//     ) {
//       if (history.location.pathname.includes('project-preview')) {
//         ChangeProjectNameInPreview(ProjectName);
//       } else {
//         ChangeProjectName(ProjectName);
//       }
//     } else {
//       if (history.location.pathname.includes('project-preview')) {
//         ChangeProjectNameInPreview(editProjectNameValue);
//       } else {
//         ChangeProjectName(editProjectNameValue);
//       }
//     }
//     seteditProjectNameValue(undefined);
//     setisEditProjectName(false);
//     if (props.setchanges !== undefined) {
//       props.setchanges(true);
//     }
//   };

//   return (
//     <>
//       <div className="top-bar d-flex">
//         <div className="topbar-menu d-flex">
//           <div className="d-flex topbar-wraper">
//             <div className="d-flex label-edit align-items-center">
//               <div className="edit-content">
//                 <input
//                   className={isEditProjectName && 'input-border'}
//                   autoFocus
//                   disabled={!isEditProjectName}
//                   type="text"
//                   id="lname"
//                   name="lname"
//                   value={isEditProjectName ? editProjectNameValue : ProjectName}
//                   onChange={e => seteditProjectNameValue(e.target.value)}
//                 />
//               </div>
//               {ProjectName && (
//                 <div className="edit-icon d-flex">
//                   {!isEditProjectName && (
//                     <span
//                       className="icon-wrap"
//                       onClick={() => {
//                         setisEditProjectName(true);
//                         seteditProjectNameValue(ProjectName);
//                       }}
//                     >
//                       <svg
//                         width="16px"
//                         height="16px"
//                         version="1.1"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 512 512"
//                         enable-background="new 0 0 512 512"
//                       >
//                         <g>
//                           <g>
//                             <path d="m455.1,137.9l-32.4,32.4-81-81.1 32.4-32.4c6.6-6.6 18.1-6.6 24.7,0l56.3,56.4c6.8,6.8 6.8,17.9 0,24.7zm-270.7,271l-81-81.1 209.4-209.7 81,81.1-209.4,209.7zm-99.7-42l60.6,60.7-84.4,23.8 23.8-84.5zm399.3-282.6l-56.3-56.4c-11-11-50.7-31.8-82.4,0l-285.3,285.5c-2.5,2.5-4.3,5.5-5.2,8.9l-43,153.1c-2,7.1 0.1,14.7 5.2,20 5.2,5.3 15.6,6.2 20,5.2l153-43.1c3.4-0.9 6.4-2.7 8.9-5.2l285.1-285.5c22.7-22.7 22.7-59.7 0-82.5z" />
//                           </g>
//                         </g>
//                       </svg>
//                     </span>
//                   )}
//                   {isEditProjectName && (
//                     <>
//                       <span
//                         className="icon-wrap"
//                         onClick={() => {
//                           editProjectName();
//                         }}
//                       >
//                         <svg
//                           width="24px"
//                           height="24px"
//                           viewBox="0 0 24 24"
//                           fill=""
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             fill-rule="evenodd"
//                             clip-rule="evenodd"
//                             d="M19.8198 6.19526C20.0601 6.45561 20.0601 6.87772 19.8198 7.13807L9.9736 17.8047C9.73328 18.0651 9.34364 18.0651 9.10332 17.8047L4.18024 12.4714C3.93992 12.2111 3.93992 11.7889 4.18024 11.5286C4.42056 11.2682 4.8102 11.2682 5.05053 11.5286L9.53846 16.3905L18.9495 6.19526C19.1898 5.93491 19.5794 5.93491 19.8198 6.19526Z"
//                             fill=""
//                           />
//                         </svg>
//                       </span>
//                       <span
//                         className="icon-wrap"
//                         onClick={() => {
//                           setisEditProjectName(false);
//                         }}
//                       >
//                         <svg
//                           width="16px"
//                           height="16px"
//                           viewBox="0 0 20 20"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
//                         </svg>
//                       </span>
//                     </>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
